(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({"./src/app/index.js":[function(require,module,exports){
/**
  Base Project - Federico Sendra (https://spacedev.uy) & Ciris Information
  Jan 2015
*/
"use strict";
var _name = require("../../package.json").name;
var prefix = "ciris-" + _name;
var lenguaje = "en";

//URL backend will always be in urlapi
var mod = angular.module(_name, [
  "ngAnimate",
  "ngMessages",
  "ngTouch",
  "ngStorage",
  "ngSanitize",
  "ui.router",
  "ui.bootstrap",
  "firebase",
  "toastr",
  "satellizer",
  "angularFileUpload",
  "ui.sortable",
  "angular-loading-bar",
  "angularUtils.directives.uiBreadcrumbs",
  "pascalprecht.translate",
  "Backend",
  "angular.filter",
  require("./base").name,
  require("./login").name,
  require("./main").name,
  require("./clients").name,
  require("./customreports").name
]);

mod.config(config);
mod.run(run);

config.$inject = [
  "$locationProvider",
  "$compileProvider",
  "toastrConfig",
  "$authProvider",
  "urlApi",
  "$localStorageProvider",
  "$sessionStorageProvider",
  "cfpLoadingBarProvider",
  "$translateProvider"
];

/**
 * System configuration
 * @param  {Provider} $locationProvider
 * @param  {Provider} $compileProvider
 * @param  {Provider} toastrConfig
 * @param  {Provider} $authProvider
 * @param  {String} urlApi
 * @param  {Provider} $localStorageProvider
 * @param  {Provider} $sessionStorageProvider
 * @param  {Provider} cfpLoadingBarProvider
 * @param  {Provider} $translateProvider
 */
function config(
  $locationProvider,
  $compileProvider,
  toastrConfig,
  $authProvider,
  urlApi,
  $localStorageProvider,
  $sessionStorageProvider,
  cfpLoadingBarProvider,
  $translateProvider
) {
  html5Mode(true);
  $compileProvider.debugInfoEnabled(false);

  function html5Mode(mode) {
    if (window.history && window.history.pushState) {
      $locationProvider.html5Mode({
        enabled: mode,
        requireBase: false
      });
    }
  } //html5Mode
  $localStorageProvider.setKeyPrefix(prefix + "-");
  $sessionStorageProvider.setKeyPrefix(prefix + "-");
  configureToastr(toastrConfig);
  configureSatellizer($authProvider, urlApi);
  configureI18n($translateProvider);
  require("./base/configureLoadingBar.js")(lenguaje, cfpLoadingBarProvider);
} //function

run.$inject = [
  "$rootScope",
  "$auth",
  "$state",
  "Notifications",
  "$http",
  "$sessionStorage",
  "$localStorage"
];

/**
 * Run and state changes
 *
 * @param  {} $rootScope
 * @param  {} $auth
 * @param  {} $state
 * @param  {} Notifications
 * @param  {} $http
 * @param  {} $sessionStorage
 * @param  {} $localStorage
 */
function run(
  $rootScope,
  $auth,
  $state,
  Notifications,
  $http,
  $sessionStorage,
  $localStorage
) {
  var parStateChange = require("./stateChange.js");
  var stateChange = parStateChange(
    $auth,
    $localStorage,
    $sessionStorage,
    Notifications,
    $state,
    $http
  );
  $rootScope.$on("$stateChangeStart", stateChange);
  $rootScope.$on("$stateChangeError", notFound);

  function notFound(event, toState, toParams, fromState, fromParams, error) {
    event.preventDefault();
    $auth.logout().then(function() {
      delete $localStorage.user;
      Notifications.addCustom(
        200,
        "There were some updates on your permissions.\n" +
          "Please, log in again."
      );
      $state.go("login");
    });
  }
}

/**
 * Google and Auth config
 * @param  {Provider} $authProvider
 * @param  {String} url
 */
function configureSatellizer($authProvider, url) {
  $authProvider.storageType = "sessionStorage";
  $authProvider.loginUrl = url + "/api/login/odoo";
  $authProvider.baseUrl = url;
  $authProvider.tokenPrefix = prefix;
  $authProvider.google({
    clientId:
      "738077328040-4opl3gua0qjr3a5jm015oa0rbid0lgoa.apps.googleusercontent.com",
    url: "/api/login/google"
  });
  $authProvider.oauth1({
    name: "odoo",
    url: "/api/login/odoo",
    redirectUri:
      window.location.origin ||
      window.location.protocol + "//" + window.location.host + "/asfaltos"
  });
}

/**
 * Toast messages config
 * @param  {Provider} toastrConfig
 */
function configureToastr(toastrConfig) {
  angular.extend(toastrConfig, {
    autoDismiss: true,
    containerId: "toast-container",
    maxOpened: 0,
    newestOnTop: true,
    positionClass: "toast-top-right",
    preventDuplicates: false,
    preventOpenDuplicates: false,
    target: "body",
    allowHtml: true,
    closeButton: true,
    closeHtml: "<i class='fa fa-fw fa-times'></i>",
    extendedTimeOut: 25000,
    iconClasses: {
      error: "alert-danger",
      info: "alert-info",
      success: "alert-success",
      warning: "alert-warning"
    },
    messageClass: "toast-message",
    onHidden: null,
    onShown: null,
    onTap: null,
    progressBar: false,
    tapToDismiss: true,
    timeOut: 10000,
    titleClass: "toast-title",
    toastClass: "alert"
  });
}

/**
 * Language config
 * @param  {Provider} $translateProvider
 */
function configureI18n($translateProvider) {
  $translateProvider.useSanitizeValueStrategy(null);
  $translateProvider.translations(
    "en",
    require("../resources/i18n/en-US.json")
  );
  $translateProvider.translations(
    "es",
    require("../resources/i18n/es-CR.json")
  );
  moment.locale(lenguaje);
  $translateProvider.preferredLanguage(lenguaje);
}

module.exports = mod;

angular.element(document).ready(function() {
  angular.bootstrap(document, [mod.name], { strictDi: true });
});

},{"../../package.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/package.json","../resources/i18n/en-US.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/resources/i18n/en-US.json","../resources/i18n/es-CR.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/resources/i18n/es-CR.json","./base":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/index.js","./base/configureLoadingBar.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/configureLoadingBar.js","./clients":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/clients/index.js","./customreports":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/customreports/index.js","./login":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/login/index.js","./main":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/main/index.js","./stateChange.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/stateChange.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/node_modules/file-saver/FileSaver.js":[function(require,module,exports){
/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || (function(view) {
	"use strict";
	// IE <10 is explicitly unsupported
	if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
		return;
	}
	var
		  doc = view.document
		  // only get URL when necessary in case Blob.js hasn't overridden it yet
		, get_URL = function() {
			return view.URL || view.webkitURL || view;
		}
		, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
		, can_use_save_link = "download" in save_link
		, click = function(node) {
			var event = new MouseEvent("click");
			node.dispatchEvent(event);
		}
		, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
		, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
		, throw_outside = function(ex) {
			(view.setImmediate || view.setTimeout)(function() {
				throw ex;
			}, 0);
		}
		, force_saveable_type = "application/octet-stream"
		// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
		, arbitrary_revoke_timeout = 1000 * 40 // in ms
		, revoke = function(file) {
			var revoker = function() {
				if (typeof file === "string") { // file is an object URL
					get_URL().revokeObjectURL(file);
				} else { // file is a File
					file.remove();
				}
			};
			setTimeout(revoker, arbitrary_revoke_timeout);
		}
		, dispatch = function(filesaver, event_types, event) {
			event_types = [].concat(event_types);
			var i = event_types.length;
			while (i--) {
				var listener = filesaver["on" + event_types[i]];
				if (typeof listener === "function") {
					try {
						listener.call(filesaver, event || filesaver);
					} catch (ex) {
						throw_outside(ex);
					}
				}
			}
		}
		, auto_bom = function(blob) {
			// prepend BOM for UTF-8 XML and text/* types (including HTML)
			// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
			if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
				return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
			}
			return blob;
		}
		, FileSaver = function(blob, name, no_auto_bom) {
			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			// First try a.download, then web filesystem, then object URLs
			var
				  filesaver = this
				, type = blob.type
				, force = type === force_saveable_type
				, object_url
				, dispatch_all = function() {
					dispatch(filesaver, "writestart progress write writeend".split(" "));
				}
				// on any filesys errors revert to saving with object URLs
				, fs_error = function() {
					if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
						// Safari doesn't allow downloading of blob urls
						var reader = new FileReader();
						reader.onloadend = function() {
							var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
							var popup = view.open(url, '_blank');
							if(!popup) view.location.href = url;
							url=undefined; // release reference before dispatching
							filesaver.readyState = filesaver.DONE;
							dispatch_all();
						};
						reader.readAsDataURL(blob);
						filesaver.readyState = filesaver.INIT;
						return;
					}
					// don't create more object URLs than needed
					if (!object_url) {
						object_url = get_URL().createObjectURL(blob);
					}
					if (force) {
						view.location.href = object_url;
					} else {
						var opened = view.open(object_url, "_blank");
						if (!opened) {
							// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
							view.location.href = object_url;
						}
					}
					filesaver.readyState = filesaver.DONE;
					dispatch_all();
					revoke(object_url);
				}
			;
			filesaver.readyState = filesaver.INIT;

			if (can_use_save_link) {
				object_url = get_URL().createObjectURL(blob);
				setTimeout(function() {
					save_link.href = object_url;
					save_link.download = name;
					click(save_link);
					dispatch_all();
					revoke(object_url);
					filesaver.readyState = filesaver.DONE;
				});
				return;
			}

			fs_error();
		}
		, FS_proto = FileSaver.prototype
		, saveAs = function(blob, name, no_auto_bom) {
			return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
		}
	;
	// IE 10+ (native saveAs)
	if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
		return function(blob, name, no_auto_bom) {
			name = name || blob.name || "download";

			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			return navigator.msSaveOrOpenBlob(blob, name);
		};
	}

	FS_proto.abort = function(){};
	FS_proto.readyState = FS_proto.INIT = 0;
	FS_proto.WRITING = 1;
	FS_proto.DONE = 2;

	FS_proto.error =
	FS_proto.onwritestart =
	FS_proto.onprogress =
	FS_proto.onwrite =
	FS_proto.onabort =
	FS_proto.onerror =
	FS_proto.onwriteend =
		null;

	return saveAs;
}(
	   typeof self !== "undefined" && self
	|| typeof window !== "undefined" && window
	|| this.content
));
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
  module.exports.saveAs = saveAs;
} else if ((typeof define !== "undefined" && define !== null) && (define.amd !== null)) {
  define("FileSaver.js", function() {
    return saveAs;
  });
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/package.json":[function(require,module,exports){
module.exports={
  "name": "BaseProject",
  "version": "1.5.0",
  "description": "Base Project with utilities, building files, and suggested architecture for frontend development",
  "main": "src/app/index.js",
  "author": "Pablo Peraza",
  "devDependencies": {
    "bower": "^1.6.5",
    "browser-sync": "^2.12.3",
    "browserify": "^8.1.0",
    "connect-history-api-fallback": "0.0.5",
    "gulp": "^3.8.10",
    "gulp-angular-templatecache": "^1.5.0",
    "gulp-complexity": "^0.3.2",
    "gulp-concat": "^2.4.3",
    "gulp-jscs": "^3.0.2",
    "gulp-jshint": "^1.11.2",
    "gulp-jsinspect": "^2.0.0",
    "gulp-less": "^3.0.5",
    "gulp-minify-html": "^0.1.8",
    "gulp-ng-constant": "^0.3.0",
    "gulp-notify": "^2.2.0",
    "gulp-plumber": "^1.0.1",
    "gulp-rename": "^1.2.2",
    "gulp-size": "^2.0.0",
    "gulp-sloc": "^1.0.4",
    "gulp-sourcemaps": "^1.3.0",
    "gulp-uglify": "^1.1.0",
    "gulp-util": "^3.0.2",
    "gulp-watch": "^4.1.0",
    "jshint": "^2.8.0",
    "jshint-stylish": "^2.0.1",
    "less-plugin-autoprefix": "^1.5.1",
    "less-plugin-clean-css": "^1.5.1",
    "lodash": "^3.7.0",
    "log": "^1.4.0",
    "main-bower-files": "^2.5.0",
    "map-stream": "0.0.6",
    "mkdirp": "^0.5.1",
    "rimraf": "^2.2.8",
    "vinyl-buffer": "^1.0.0",
    "vinyl-source-stream": "^1.0.0",
    "watchify": "^3.11.1",
    "webdriver-manager": "^8.0.0",
    "yargs": "^3.26.0"
  },
  "dependencies": {
    "angular-file-upload": "^2.5.0",
    "file-saver": "^1.3.8"
  },
  "scripts": {
    "lint": "lessc --lint src/less/main.less"
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/configureLoadingBar.js":[function(require,module,exports){
"use strict";

module.exports = configureLoadingBar;

var ingles = require("../../resources/i18n/en-US.json");
var espaniol = require("../../resources/i18n/es-CR.json");

function configureLoadingBar(language, cfpLoadingBarProvider) {
  cfpLoadingBarProvider.includeSpinner = false;

  cfpLoadingBarProvider.loadingBarTemplate =
    "<div id='loading-bar'>" +
    "<aside class='splash-title'>" +
    "<h1>" +
    texts(language, "title") +
    "</h1>" +
    "<div class='bar'></div>" +
    "<p>" +
    texts(language, "loadingbar") +
    "</p>" +
    "<i class='fa fa-fw fa-circle-o-notch fa-2x fa-spin'></i>" +
    "</aside>" +
    "</div>";
}

function texts(language, key) {
  switch (language) {
    case "es":
      return espaniol[key];
    default:
      return ingles[key];
  }
}

},{"../../resources/i18n/en-US.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/resources/i18n/en-US.json","../../resources/i18n/es-CR.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/resources/i18n/es-CR.json"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/directives/btnBack.js":[function(require,module,exports){
"use strict";
module.exports = btnBack;

function btnBack() {
  return {
    restric: "EA",
    link: link
  };
}

function link(scope, elem) {
  elem.on("click", function() {
    window.history.back();
  });
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/directives/cisEnter.js":[function(require,module,exports){
"use strict";

module.exports = cisEnter;

function cisEnter() {
  return function(scope, element, attrs) {
    element.bind("keydown keypress", function(event) {
      if (event.which === 13 || event.which === 32 || event.which === 188) {
        scope.$apply(function() {
          scope.$eval(attrs.cisEnter);
        });
        event.preventDefault();
      }
    });
  };
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/directives/cisMinimize.js":[function(require,module,exports){
"use strict";

module.exports = cisMinimize;

function cisMinimize() {
  return {
    restrict: "A",
    scope: true,
    link: function($scope, $element) {
      if ($(window).width() < 768) {
        darken();
        styles();
      }
      $element.on("click", minimize);
      function minimize() {
        darken();
        styles();
      }
    }
  };
}

function styles() {
  $("#wrapper").toggleClass("minimized");
  $("#logo").toggleClass("hideLogo");
  if ($("#wrapper").hasClass("minimized")) {
    $("#MinifierIcon").removeClass("fa-chevron-left");
    $("#MinifierIcon").addClass("fa-chevron-right");
  } else {
    $("#MinifierIcon").removeClass("fa-chevron-right");
    $("#MinifierIcon").addClass("fa-chevron-left");
  }
}

function darken() {
  if ($(window).width() < 768) {
    if ($("#wrapper").hasClass("minimized")) {
      $("#darken").removeClass("hidden");
    } else {
      $("#darken").addClass("hidden");
    }
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/directives/cisMonthpicker.js":[function(require,module,exports){
"use strict";
module.exports = cisMonthpicker;

cisMonthpicker.$inject = [];
function cisMonthpicker() {
  return {
    restrict: "AE",
    require: "ngModel",
    replace: true,
    scope: {},
    templateUrl: "base/views/cisMonthpicker.html",
    link: link
  };
  function link($scope, $elem, $attrs, ngModelCtrl) {
    $scope.today = moment();
    $scope.year = year;
    $scope.open = open;
    $scope.disableMonth = disableMonth;
    $scope.activeMonth = activeMonth;
    $scope.moveYear = moveYear;
    $scope.setDate = setDate;
    $scope.hidden = true;
    $scope.showBackButton = showBackButton;

    $scope.$watch(
      function() {
        return ngModelCtrl.$viewValue;
      },
      function(val) {
        $scope.model = val;
      }
    );

    function moveYear(val) {
      var newDate = moment($scope.model, "YYYY-MM-DD").add(val, "years");
      if (newDate.year() >= $scope.today.year()) {
        $scope.model = newDate.format("YYYY-MM-DD");
        $scope.months = months($scope.model);
      }
    }

    function year() {
      return moment($scope.model, "YYYY-MM-DD").format("YYYY");
    }

    function months(startDate) {
      var point = moment(startDate).startOf("year");
      var data = [];
      var length = 12;
      for (var i = 0; i < length; i += 1) {
        data.push(moment(point).add(i, "months"));
      }
      return data;
    }

    function disableMonth(month) {
      return month.isBefore(moment($scope.today).startOf("month"));
    }

    function activeMonth(month) {
      return month.month() === moment($scope.model, "YYYY-MM-DD").month();
    }

    function setDate(month) {
      ngModelCtrl.$setViewValue(month.format("YYYY-MM-DD"));
      $scope.model = ngModelCtrl.$viewValue;
      $scope.hidden = true;
    }

    function open() {
      if ($scope.hidden) {
        if (ngModelCtrl.$viewValue) {
          $scope.model = ngModelCtrl.$viewValue;
        } else {
          $scope.model = moment($scope.today).format("YYYY-MM-DD");
        }
        $scope.months = months($scope.model);
        $scope.hidden = false;
      } else {
        $scope.hidden = true;
      }
    }

    function showBackButton() {
      var lastYear = moment($scope.model, "YYYY-MM-DD")
        .subtract(1, "years")
        .year();
      var currentYear = $scope.today.year();
      return lastYear >= currentYear;
    }
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/directives/cisNumericalInput.js":[function(require,module,exports){
"use strict";
module.exports = cisNumericalInput;
cisNumericalInput.$inject = ["$filter"];
function cisNumericalInput($filter) {
  return {
    require: "ngModel",
    restrict: "E",
    link: link($filter)
  };
}

function link($filter) {
  return function(scope, element, attrs, ngModelCtrl) {
    if (attrs.type === "numerical") {
      ngModelCtrl.$parsers.push(function(val) {
        var clean = val.replace(/[^0-9,\,]+/g, "");
        if (val !== clean) {
          ngModelCtrl.$setViewValue(clean);
          ngModelCtrl.$render();
        }
        if (clean === "") {
          clean = "0";
        }
        return parseFloat(clean.replace(",", "."));
      });
      ngModelCtrl.$formatters.push(function(val) {
        var DecimalCount = String(val).split(".")[1];
        var decimals = 0;
        if (DecimalCount) {
          decimals = DecimalCount.length;
        }
        return $filter("Number")(val, decimals);
      });

      element.bind("keypress", function(event) {
        if (event.keyCode === 32) {
          event.preventDefault();
        }
      });
    }
    return;
  };
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/directives/cisSwitch.js":[function(require,module,exports){
"use strict";

module.exports = cisSwitch;

function cisSwitch() {
  return {
    restrict: "EA",
    replace: true,
    templateUrl: "base/views/cisSwitch.html",
    require: "ngModel",
    scope: true,
    link: link
  };
}

function link($scope, $elem, $attr, ngModelCtrl) {
  $scope.id = uuid();
  $scope.type = $attr.type || null;
  $scope.value = false;
  $scope.apply = apply;

  $scope.$watch(
    function() {
      return $scope.$eval($attr.ngDisabled);
    },
    function(val) {
      if (val) {
        $elem.addClass("disabled");
      } else {
        $elem.removeClass("disabled");
      }
    }
  );

  $scope.$watch(
    function() {
      return ngModelCtrl.$modelValue;
    },
    function(val) {
      if (val) {
        $scope.value = ngModelCtrl.$modelValue;
      } else {
        ngModelCtrl.$setViewValue($scope.value);
      }
    }
  );

  function apply(val) {
    ngModelCtrl.$setViewValue(val);
  }
}

function uuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/directives/cisTitle.js":[function(require,module,exports){
"use strict";

module.exports = title;

title.$inject = ["$rootScope", "$timeout", "$translate"];
function title($rootScope, $timeout, $translate) {
  return {
    restrict: "EA",
    scope: true,
    link: link
  };

  function link(scope, element) {
    $rootScope.$on("$stateChangeStart", change);

    function change(event, toState) {
      var title = headliner(toState);
      $timeout(function() {
        element.text(title);
      });
    }

    function headliner(toState) {
      var title = $translate.instant("title");
      if (toState.data && toState.data.title) {
        return $translate.instant(toState.data.title) + " | " + title;
      }
      return title;
    }
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/directives/clickOn.js":[function(require,module,exports){
"use strict";
module.exports = clickEn;

function clickEn() {
  return {
    restrict: "A",
    link: link
  };
}

function link($scope, $elem, attr) {
  $elem.on("click", function() {
    $("#" + attr.clickEn).click();
  });
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/directives/compareTo.js":[function(require,module,exports){
"use strict";

module.exports = compareTo;

function compareTo() {
  return {
    require: "ngModel",
    scope: {
      otherModelValue: "=compareTo"
    },
    link: link
  };
}

function link(scope, element, attributes, ngModel) {
  ngModel.$validators.compareTo = function(modelValue) {
    return modelValue === scope.otherModelValue;
  };
  scope.$watch("otherModelValue", function() {
    ngModel.$validate();
  });
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/directives/dateInput.js":[function(require,module,exports){
"use strict";
module.exports = dateInput;

function dateInput() {
  return {
    restrict: "AE",
    require: "?ngModel",
    link: link
  };
}

function link(scope, element, attrs, ngModelCtrl) {
  $(function() {
    $(element)
      .datepicker({
        dateFormat: "mm/dd/yy",
        minDate: 0,
        onSelect: function(date) {
          scope.$apply(function() {
            ngModelCtrl.$setViewValue(moment(date).format("MM/DD/YYYY"));
          });
        }
      })
      .keydown(function(e) {
        if (e.which !== 9) {
          e.preventDefault();
        }
      });
  });

  ngModelCtrl.$formatters.push(function(val) {
    if (val) {
      return moment(val).format("MM/DD/YYYY");
    }
  });
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/filters.js":[function(require,module,exports){
"use strict";

exports.date = date;
exports.percentage = percentage;
exports.month = month;

/**
 * Helper function for date formatting
 * @return {Date} Date
 */
function date() {
  var dateFormat = "YYYY-MM-DD";
  return filter;

  function filter(date, displayFormat) {
    if (date) {
      return moment(date, dateFormat).format(displayFormat);
    } else {
      return "";
    }
  }
}

percentage.$inject = ["$filter"];

/**
 * Gets a percentage based on a number (defaults to 2 decimals)
 * @param  {} $filter
 * @return \{{{type}}\} {{description}}{{}}
 */
function percentage($filter) {
  return filter;
  function filter(num, decimals) {
    if (isNumber(num)) {
      return $filter("number")(num * 100, decimals || 2) + "%";
    }
    return "Undefined";
  }

  function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }
}

/**
 * Formats month to 'MMM' format
 * @return {Date} Formatted date
 */
function month() {
  return function monthInner(num) {
    return moment()
      .month(num)
      .format("MMM");
  };
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/index.js":[function(require,module,exports){
"use strict";

var angular = window.angular;

var mod = angular.module("BaseProject.base", []);

mod.config(require("./routes"));

mod.controller("NavigationCtrl", require("./services/navigationCtrl.js"));

mod.factory("Notifications", require("./services/notifications"));
mod.factory("Futures", require("./services/futures"));

mod.directive("clickOn", require("./directives/clickOn.js"));
mod.directive("cisSwitch", require("./directives/cisSwitch.js"));
mod.directive("cisTitle", require("./directives/cisTitle.js"));
mod.directive("cisMinimize", require("./directives/cisMinimize.js"));
mod.directive("numerical", require("./directives/cisNumericalInput.js"));
mod.directive("cisEnter", require("./directives/cisEnter.js"));
mod.directive("compareTo", require("./directives/compareTo.js"));
mod.directive("btnBack", require("./directives/btnBack.js"));
mod.directive("dateInput", require("./directives/dateInput"));
mod.directive("cisMonthpicker", require("./directives/cisMonthpicker.js"));

var filters = require("./filters");
mod.filter("Date", filters.date);
mod.filter("Percentage", filters.percentage);
mod.filter("month", filters.month);

module.exports = mod;

},{"./directives/btnBack.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/directives/btnBack.js","./directives/cisEnter.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/directives/cisEnter.js","./directives/cisMinimize.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/directives/cisMinimize.js","./directives/cisMonthpicker.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/directives/cisMonthpicker.js","./directives/cisNumericalInput.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/directives/cisNumericalInput.js","./directives/cisSwitch.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/directives/cisSwitch.js","./directives/cisTitle.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/directives/cisTitle.js","./directives/clickOn.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/directives/clickOn.js","./directives/compareTo.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/directives/compareTo.js","./directives/dateInput":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/directives/dateInput.js","./filters":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/filters.js","./routes":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/routes.js","./services/futures":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/services/futures.js","./services/navigationCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/services/navigationCtrl.js","./services/notifications":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/services/notifications.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/routes.js":[function(require,module,exports){
"use strict";

module.exports = routes;
routes.$inject = ["$stateProvider", "$urlRouterProvider"];

function routes($stateProvider, $urlRouterProvider) {
  $stateProvider.state("index", {
    templateUrl: "base/views/template.html",
    abstract: true
  });

  $stateProvider.state("404", {
    url: "/404",
    templateUrl: "base/views/404.html",
    free: true,
    data: {
      title: "routes.base.404"
    }
  });

  $stateProvider.state("403", {
    url: "/403",
    templateUrl: "base/views/403.html",
    free: true,
    data: {
      title: "routes.base.403"
    }
  });

  $urlRouterProvider.otherwise("/");
} //routes

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/services/futures.js":[function(require,module,exports){
"use strict";

module.exports = futures;

function futures($q, $timeout) {
  futures.aFuture = aFuture;
  futures.aRejected = aRejected;
  return futures;

  function aFuture(value, timeout) {
    return promise("resolve", value, timeout);
  } //function

  function aRejected(value, timeout) {
    return promise("reject", value, timeout);
  } //function

  function promise(_type, value, timeout) {
    try {
      var future = $q.defer();
      $timeout(
        function() {
          future[_type](value);
        },
        _.isUndefined(timeout) ? 0 : timeout
      );
      return future.promise;
    } catch (ex) {
      return ex;
    } //catch
  } //function
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/services/navigationCtrl.js":[function(require,module,exports){
"use strict";

module.exports = NavigationCtrl;

NavigationCtrl.$inject = [
  "$state",
  "$localStorage",
  "Notifications",
  "$auth",
  "$sessionStorage",
  "$translate"
];
function NavigationCtrl(
  $state,
  $localStorage,
  Notifications,
  $auth,
  $sessionStorage,
  $translate
) {
  var nav = this;
  nav.logout = logout;
  nav.today = moment();
  nav.getTitle = getTitle;
  nav.icon = icon;
  nav.user = $sessionStorage.user;
  nav.states = filterUnwantedStates($state.get());

  function logout() {
    $auth.logout().then(function() {
      delete $sessionStorage.user;
      delete $localStorage.user;
      Notifications.addCustom(200, "Successfully logged out");
      $state.go("login");
    });
  }

  function getTitle() {
    if ($state.current.data && $state.current.data.title) {
      return $translate.instant($state.current.data.title);
    } else {
      return "Error";
    }
  }

  function icon() {
    if ($state.current.data && $state.current.data.icon) {
      return $state.current.data.icon;
    } else {
      return "fa-home";
    }
  }

  function filterUnwantedStates(states) {
    var filteredStates = filterStatesByCredentials(states);
    return _.reject(filteredStates, function(state) {
      return (
        state.abstract ||
        state.name === "login" ||
        state.name === "404" ||
        state.name === "403" ||
        state.data.hidden ||
        state.name.match(/-one((\.\w*)?)$/) ||
        state.name.match(/^(\w*\.\w*)\..*$/)
      );
    });
  }

  function filterStatesByCredentials(states) {
    var p = $auth.getPayload().permissions;
    if (p && all(p.user) && all(p.role)) {
      return _.reject(states, function(state) {
        return state.name === "index.administration";
      });
    }
    return states;
  }

  function all(permissions) {
    return _.every(_.values(permissions), function(value) {
      return !value;
    });
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/base/services/notifications.js":[function(require,module,exports){
"use strict";

module.exports = notifications;

notifications.$inject = ["toastr"];

function notifications(toastr) {
  notifications.add = add;
  notifications.addCustom = addCustom;
  return notifications;

  function type(status) {
    switch (String(status).substr(0, 1)) {
      case "2":
        return toastr.success;
      case "4":
        return toastr.info;
      case "5":
        return toastr.error;
      default:
        return toastr.warning;
    }
  }

  function add(status, obj) {
    type(status)(ofStatus(status, obj));
  } //function

  function addCustom(status, message) {
    type(status)(message);
  } //function

  function ofStatus(status, obj) {
    var elem = obj || "document";
    switch (status) {
      case 0:
        return "<strong>0</strong> - There's no communication to the server";
      case 200:
        return "<strong>200</strong> - Your request has been successful";
      case 201:
        return (
          "<strong>201</strong> - The element " +
          elem +
          " has been successfully saved"
        );
      case 204:
        return (
          "<strong>204</strong> - The element " +
          elem +
          " has been successfully deleted"
        );
      case 400:
        return "<strong>400</strong> - Missing data required to complete the request";
      case 403:
        return "<strong>493</strong> - Invalid credentials";
      case 404:
        return "<strong>404</strong> - " + elem + " not found";
      case 409:
        return (
          "<strong>409</strong> - " +
          "The action can't execute because it will generate conflict"
        );
      case 470:
        return (
          "<strong>470</strong> - Identification of " + elem + " is not valid"
        );
      case 471:
        return "<strong>471</strong> - " + elem + " already exists";
      case 472:
        return "<strong>472</strong> - Expired credentials";
      case 473:
        return "<strong>473</strong> - Incorrect credentials";
      case 500:
        return (
          "<strong>500</strong> - " +
          "There has been an unexpected error, please try again later"
        );
      case 501:
        return "<strong>501</strong> - The service has not been implemented";
      case 530:
        return (
          "<strong>530</strong> - We couldn't complete your request because" +
          " It took us too long to process, please try again later"
        );
      default:
        return "<strong>0</strong> - Notification without a message";
    }
  }
} //functions

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/clients/controllers/analyticsCtrl.js":[function(require,module,exports){
"use strict";

module.exports = analyticsCtrl;

var setClientStatus = require("../models/setStatus.js").setClientStatus;

analyticsCtrl.$inject = ["clients"];
function analyticsCtrl(clients) {
  var vm = this;
  vm.clients = setClientStatus(clients);

  clients.$watch(function(event) {
    vm.clients = setClientStatus(clients);
    calculateAnalytics();
  });

  calculateAnalytics();

  /**
   * Calculates the amount of clients with their different states (paid, free, expired, deactivated, etc)
   */
  function calculateAnalytics() {
    vm.totalClients = vm.clients.length;

    //we initialize each total at 0
    var paying = 0,
      free = 0,
      trial = 0,
      expired = 0,
      deactivated = 0,
      acceptedTos = 0,
      completedTour = 0;

    //we initialize these totals at total clients and substract for each that have completed it
    acceptedTos = vm.totalClients;
    completedTour = vm.totalClients;

    for (var i = 0; i < vm.totalClients; i++) {
      var client = vm.clients[i];

      if (client.status == "Deactivated") {
        deactivated++;
      } else if (client.status == "Paying") {
        paying++;
      } else if (client.status == "Free User") {
        free++;
      } else if (client.status == "Trial User") {
        trial++;
      } else if (client.status == "Expired") {
        expired++;
      }

      if (client.tourFirstTime) {
        completedTour--;
      }

      if (client.firstTime) {
        acceptedTos--;
      }
    }

    vm.totalDeactivated = deactivated;
    vm.totalPaying = paying;
    vm.totalFree = free;
    vm.totalTrial = trial;
    vm.totalExpired = expired;
    vm.totalCompletedTour = completedTour;
    vm.totalFirstTime = acceptedTos;
  }
}

},{"../models/setStatus.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/clients/models/setStatus.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/clients/controllers/listClientCtrl.js":[function(require,module,exports){
"use strict";

module.exports = listClientCtrl;

var setClientStatus = require("../models/setStatus.js").setClientStatus;

listClientCtrl.$inject = [
  "clients",
  "$sessionStorage",
  "cfpLoadingBar",
  "ClientAPI",
  "$state"
];
function listClientCtrl(
  clients,
  $sessionStorage,
  cfpLoadingBar,
  ClientAPI,
  $state
) {
  var vm = this;
  vm.filterOptions = [
    "All",
    "Paying",
    "Trial User",
    "Free User",
    "Expired",
    "───────────────",
    "Deactivated"
  ];
  vm.filterBy = vm.filterOptions[0];
  vm.clients = setClientStatus(clients);
  vm.showClient = showClient;
  vm.remove = remove;

  /**
   * Filters clients by the criteria
   * @param  {Object} client Client
   * @param  {String} criteria Filter criteria
   */
  function showClient(client, criteria) {
    if (criteria === "All") {
      return true;
    }
    if (client.status === criteria) {
      return true;
    }
  }

  /**
   * Deletes a client with everything associated to that account
   * @param  {String} clientId Client Id
   */
  function remove(clientId) {
    var msj =
      "Are you sure you want to delete this client?\n" +
      "This action will remove some related data (devices, reports, service requests)";
    if (confirm(msj)) {
      cfpLoadingBar.start();
      ClientAPI.removeCustomers(clientId).then(function() {
        ClientAPI.removeEmployees(clientId)
          .then(function() {
            ClientAPI.removeDevices(clientId).then(function() {
              ClientAPI.removeReports(clientId)
                .then(function() {
                  ClientAPI.removeIncompletes(clientId)
                    .then(function() {
                      ClientAPI.removeCustRequests(clientId)
                        .then(function() {
                          ClientAPI.removeClient(clientId)
                            .then(function() {
                              $state.go("index.clients");
                              cfpLoadingBar.complete();
                            })
                            .catch(function(exp) {
                              cfpLoadingBar.complete();
                              Raven.captureException(exp);
                            });
                        })
                        .catch(function(exp) {
                          cfpLoadingBar.complete();
                          Raven.captureException(exp);
                        });
                    })
                    .catch(function(exp) {
                      cfpLoadingBar.complete();
                      Raven.captureException(exp);
                    });
                })
                .catch(function(exp) {
                  cfpLoadingBar.complete();
                  Raven.captureException(exp);
                });
            });
          })
          .catch(function(exp) {
            cfpLoadingBar.complete();
            Raven.captureException(exp);
            Notifications.addCustom(500, "Error removing the client.");
          });
      });
    }
  }

  clients.$watch(function(event) {
    vm.clients = setClientStatus(clients);
  });
}

},{"../models/setStatus.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/clients/models/setStatus.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/clients/controllers/listTrialCtrl.js":[function(require,module,exports){
"use strict";

module.exports = listTrialCtrl;
var setTrialStatus = require("../models/setStatus.js").setTrialStatus;

listTrialCtrl.$inject = ["trialUsers"];
function listTrialCtrl(trialUsers) {
  var vm = this;
  vm.trialUsers = setTrialStatus(trialUsers);

  trialUsers.$watch(function(event) {
    if (event === "child_added") {
      vm.trialUsers = setTrialStatus(trialUsers);
    }
  });
}

},{"../models/setStatus.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/clients/models/setStatus.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/clients/controllers/rest/clientAPI.js":[function(require,module,exports){
"use strict";

module.exports = ClientAPI;

ClientAPI.$inject = [
  "urlApi",
  "$firebaseArray",
  "$firebaseObject",
  "Notifications",
  "$http",
  "urlNode",
  "$q"
];

function ClientAPI(
  urlApi,
  $firebaseArray,
  $firebaseObject,
  Notifications,
  $http,
  urlNode,
  $q
) {
  var rootRef = new Firebase(urlApi);
  ClientAPI.get = get;
  ClientAPI.listBy = listBy;
  ClientAPI.save = save;
  ClientAPI.remove = remove;
  ClientAPI.edit = edit;
  ClientAPI.list = list;
  ClientAPI.getSummary = getSummary;
  ClientAPI.removeCustomers = removeCustomers;
  ClientAPI.removeClient = removeClient;
  ClientAPI.removeEmployees = removeEmployees;
  ClientAPI.removeDevices = removeDevices;
  ClientAPI.removeIncompletes = removeIncompletes;
  ClientAPI.removeReports = removeReports;
  ClientAPI.removeCustRequests = removeCustRequests;
  //ClientAPI.saveCustomReportClient = saveCustomReportClient;
  ClientAPI.getCustomReports = getCustomReports;
  //ClientAPI.removeCustomReportClient = removeCustomReportClient;
  return ClientAPI;

  /**
   * Returns a client
   * @param  {String} idClient Client Id
   * @return {Object} Client returned
   */
  function get(idClient) {
    return $firebaseObject(rootRef.child("Clients").child(idClient)).$loaded(
      function(resp) {
        return resp;
      }
    );
  }

  /**
   * Returns a list of all clients in the system
   * @return {Object} Array with all clients
   */
  function list() {
    return $firebaseArray(rootRef.child("Clients")).$loaded(function(resp) {
      return resp;
    });
  }

  /**
   * Returns a list of all clients ordered, filtered by a specific value
   * @param  {} value order direction
   * @param  {} status filter value
   */
  function listBy(value, status) {
    var listRef = rootRef
      .child("Clients")
      .orderByChild(value)
      .equalTo(status);
    return $firebaseArray(listRef).$loaded(function(resp) {
      return resp;
    });
  }

  /**
   * Deletes a client object from our system
   * @param  {Object} obj Client to remove
   */
  function remove(obj) {
    return ClientAPI.get(obj.$id).then(function(resp) {
      resp.$remove().then(ok, error);
    });

    function ok(resp) {
      Notifications.addCustom(200, "Client deleted successfully");
      return resp;
    }

    function error(resp) {
      console.debug(resp);
      Notifications.addCustom(500, "There was a problem.");
      return resp;
    }
  }

  /**
   * Deletes a client from Id
   * @param  {String} clientID Client Id
   */
  function removeClient(clientID) {
    return ClientAPI.get(clientID).then(function(resp) {
      resp.$remove().then(ok, error);
    });

    function ok(resp) {
      //After removing from firebase client we need to remove it from our mongodb auth database
      var future = $q.defer();
      $http.post(urlNode + "api/auth/removeUsers", [clientID]).then(
        function(res) {
          Notifications.addCustom(200, "Client deleted successfully");
          future.resolve(res.data);
        },
        function(err) {
          Notifications.addCustom(200, "Error deleting the client");
          future.reject(err.data);
        }
      );
      return future.promise;
    }

    function error(resp) {
      console.debug(resp);
      Notifications.addCustom(500, "There was a problem.");
      return resp;
    }
  }

  /**
   * Adds or edits and object
   * @param  {Object} obj Client Information
   * @return {String} Id of new/edited object
   */
  function save(obj) {
    if (obj.$id) {
      return edit(obj);
    } else {
      return create(obj);
    }
  }

  /**
   * Creates new client
   * @param {Object} obj Client object
   * @return {Object} Firebase response
   */
  function create(obj) {
    return $firebaseArray(rootRef.child("Clients"))
      .$add(obj)
      .then(ok, error);

    function ok(resp) {
      Notifications.addCustom(200, "Client created successfully");
      return resp.key();
    }

    function error(resp) {
      Notifications.addCustom(500, "There was a problem.");
      return resp;
    }
  }

  /**
   * Edits a client
   * @param {Object} obj Client object
   * @return {Object} Firebase response
   */
  function edit(obj) {
    return obj.$save().then(ok, error);
    function ok(resp) {
      Notifications.addCustom(200, "Information saved successfully");
      return resp.key();
    }

    function error(resp) {
      Notifications.addCustom(500, "There was a problem.");
      return resp;
    }
  }

  /**
   * Gets summary information of a client to display
   * @param  {} idClient
   */
  function getSummary(idClient) {
    function getColection(branch) {
      return rootRef
        .child(branch)
        .child(idClient)
        .once("value", function(snapshot) {
          return snapshot;
        });
    }

    function groupByType(reports) {
      var repGroups = { qty: 0 };
      _.forEach(reports, function(child) {
        _.forEach(child, function(val, key) {
          if (!repGroups[key]) {
            repGroups[key] = [];
          }
          var array = _.toArray(val);
          repGroups[key] = repGroups[key].concat(array);
          repGroups.qty += array.length;
        });
      });
      return repGroups;
    }

    function toArray(obj) {
      var arr = [];
      _.forEach(obj, function(val, key) {
        val.$id = key;
        arr.push(val);
      });
      return arr;
    }

    return getColection("Employee").then(function(employees) {
      var data = {};
      data.employees = toArray(employees.val());
      return getColection("Customer").then(function(customers) {
        data.customers = toArray(customers.val());
        return getColection("Incomplete").then(function(incompletes) {
          data.incompleteReps = groupByType(incompletes.val());
          return getColection("Reports").then(function(completes) {
            data.completeReps = groupByType(completes.val());
            return data;
          });
        });
      });
    });
  }

  /**
   * Deletes all customers from a client
   * @param  {String} clientID Client Id
   */
  function removeCustomers(clientID) {
    return rootRef
      .child("Customer")
      .child(clientID)
      .once("value", function(snap) {
        var customersAllowed = [];
        var resp = snap.val();
        _.forEach(resp, function(ele) {
          if (ele.uid) {
            customersAllowed.push(ele.uid);
          }
        });
        //We remove it from customer table on firebase and also from mongodb auth database.
        //This is necessary because some customers can login from customer portal.
        var future = $q.defer();
        $http.post(urlNode + "api/auth/removeUsers", customersAllowed).then(
          function(res) {
            rootRef
              .child("Customer")
              .child(clientID)
              .remove()
              .then(ok, error);
            future.resolve(res.data);
          },
          function(err) {
            future.reject(err.data);
          }
        );
        return future.promise;
      });

    function ok(resp) {
      Notifications.addCustom(200, "Customers deleted");
      return resp;
    }

    function error(resp) {
      console.debug(resp);
      Notifications.addCustom(500, "There was a problem deleting customers.");
      return resp;
    }
  }

  /**
   * Deletes employees from a client
   * @param  {String} clientID Client Id
   */
  function removeEmployees(clientID) {
    return rootRef
      .child("Employee")
      .child(clientID)
      .once("value", function(snap) {
        var uids = [];

        var obj = snap.val();
        if (obj) {
          _.forEach(obj, function(val, key) {
            uids.push(obj[key].uid);
          });
        }
        var future = $q.defer();

        //Same as client and customers, employees auth needs to be removed
        $http.post(urlNode + "api/auth/removeUsers", uids).then(
          function(res) {
            rootRef
              .child("Employee")
              .child(clientID)
              .remove()
              .then(ok, error);
            future.resolve(res.data);
          },
          function(err) {
            future.reject(err.data);
          }
        );

        return future.promise;
      });

    function ok(resp) {
      Notifications.addCustom(200, "Employees deleted");
      return resp;
    }

    function error(resp) {
      console.debug(resp);
      Notifications.addCustom(500, "There was a problem deleting employees.");
      return resp;
    }
  }

  /**
   * Deletes devices from a Client
   * @param  {String} clientID Client Id
   */
  function removeDevices(clientID) {
    return rootRef
      .child("Devices")
      .child(clientID)
      .remove()
      .then(ok, error);

    function ok(resp) {
      Notifications.addCustom(200, "Devices deleted");
      return resp;
    }

    function error(resp) {
      console.debug(resp);
      Notifications.addCustom(500, "There was a problem deleting devices.");
      return resp;
    }
  }

  /**
   * Delete all incomplete reports from a client (from all customers)
   * @param  {String} clientID Client Id
   * @return {Object} Firebase response
   */
  function removeIncompletes(clientID) {
    return rootRef
      .child("Incomplete")
      .child(clientID)
      .remove()
      .then(ok, error);

    function ok(resp) {
      Notifications.addCustom(200, "Incomplete reports deleted");
      return resp;
    }

    function error(resp) {
      console.debug(resp);
      Notifications.addCustom(
        500,
        "There was a problem deleting incomplete reports."
      );
      return resp;
    }
  }

  /**
   * Delete all clients reports (from all the customers)
   * @param  {String} clientID Client Id
   */
  function removeReports(clientID) {
    return rootRef
      .child("Reports")
      .child(clientID)
      .remove()
      .then(ok, error);

    function ok(resp) {
      Notifications.addCustom(200, "Reports deleted");
      return resp;
    }

    function error(resp) {
      console.debug(resp);
      Notifications.addCustom(500, "There was a problem deleting reports.");
      return resp;
    }
  }

  /**
   * Deletes all requests from a client (and all its customers)
   * @param  {String} clientID Client Id
   */
  function removeCustRequests(clientID) {
    return rootRef
      .child("Requests")
      .child(clientID)
      .remove()
      .then(ok, error);

    function ok(resp) {
      Notifications.addCustom(200, "Customer requests deleted");
      return resp;
    }

    function error(resp) {
      console.debug(resp);
      Notifications.addCustom(500, "There was a problem customer requests.");
      return resp;
    }
  }

  function getCustomReports(clientId) {
    var query = rootRef.child("Clients").child(clientId);

    return $firebaseArray(query).$loaded(function(resp) {
      return resp;
    });
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/clients/controllers/singleClientCtrl.js":[function(require,module,exports){
"use strict";

module.exports = singleClientCtrl;

singleClientCtrl.$inject = [ "client", "summary", "UserAPI", "EmailAPI", "Notifications" ];
function singleClientCtrl( client, summary, UserAPI, EmailAPI, Notifications ) {
  var vm = this;
  vm.editable = false;
  vm.client = client;
  vm.summary = summary;
  vm.details = getDetails( summary );
  vm.deactivate = deactivate;
  vm.deactivateNow =deactivateNow;
  vm.activate = activate;
  vm.initDate = initDate;
  vm.saveDate = saveDate;
  vm.removeFree = removeFree;

  /**
   * Initializes free expiration date 
   * @param  {String} date Date
   */
  function initDate( date ) {
    if ( date ) {
      vm.freeCheck = true;
      vm.freeExpDate = date;
    }
  }


  /**
   * Activates a client and sends confirmation email
   * @param  {Object} client Client information
   */
  function activate( client ) {
    function sendReactEmail() {
      EmailAPI.sendEmail( {
        type: "REACTIVATION",
        addresses: [ client.email ],
        subject: "Account Status",
        content: {}
      } );
    }
    delete client.deactivationDate;
    delete client.deactivated;
    
    client.$save().then(sendReactEmail);

  }

  /**
   * Starts 7-day period client deactivation
   * @param  {Object} client Client information
   */
  function deactivate( client ) {
    client.deactivationDate = moment().add( 7, "day" ).format( "YYYY-MM-DD" );
    client.$save().then( function() {
      EmailAPI.sendEmail( {
        type: "USER_ACCOUNT",
        addresses: [ client.email ],
        subject: "Account Status",
        content: {}
      } );
    } );
  }

  /**
   * Suspends/deactivates client immediately
   * @param  {Object} client Client Information
   */
  function deactivateNow( client ) {

    delete client.deactivationDate;
    client.deactivated = true;

    client.$save().then( function() {
      Notifications.addCustom( 200, "User has been deactivated" );
      /*EmailAPI.sendEmail( {
        type: "GRACE_PERIOD",
        addresses: [ client.email ],
        subject: "Account Status",
        content: "Your account has been suspended, if you think this is an error, please contact us."
      } );*/
    } );
  }

  /**
   * Sets free user
   * @param  {String} date Free user expiration date
   */
  function saveDate( date ) {
    if ( date ) {
      vm.client.freeExpDate = moment( date ).format( "YYYY-MM-DD" );
      vm.client.deactivated = false;
      delete vm.client.deactivationDate;
      vm.client.$save().then( function() {
        Notifications.addCustom( 200, "User has been set as free" );
      } );
    }
  }

  /**
   * Removes free user status
   * @param  {} check
   */
  function removeFree( check ) {
    if ( !check ) {
      delete vm.client.freeExpDate;
      vm.client.$save().then( function() {
        Notifications.addCustom( 200, "User free condition has been removed" );
      } );
    }
  }

  /**
   * Helper method to construct client summary
   * @param  {} list
   */
  function getDetails( list ) {
    var table = {
      "Alarm": [],
      "Back Flow": [],
      "Emergency Exit": [],
      "Extinguisher": [],
      "Grease Cleaning": [],
      "Hood System": [],
      "Hydrant": [],
      "Monitoring": [],
      "Fire Pump": [],
      "Sensitivity": [],
      "Special Hazard": [],
      "Sprinkler": [],
      "Standpipe": [],
      "Suppression": []
    };
    _.forEach( table, function( rowVal, rowKey ) {
      var groupIncompletes = _.groupBy( list.incompleteReps[rowKey], "createdBy" );
      var groupCompletes = _.groupBy( list.completeReps[rowKey], "createdBy" );
      _.forEach( list.employees, function( employee ) {
        table[rowKey].push( {
          incQty: _.get( groupIncompletes[employee.$id], "length", 0 ),
          comQty: _.get( groupCompletes[employee.$id], "length", 0 )
        } );
      } );
    } );
    return table;
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/clients/index.js":[function(require,module,exports){
"use strict";

var _name = require("../../../package.json").name;

var mod = angular.module(_name + ".Clients", []);
mod.config(require("./routes"));

mod.factory("ClientAPI", require("./controllers/rest/clientAPI.js"));

mod.controller("ListClientCtrl", require("./controllers/listClientCtrl.js"));
mod.controller("ListTrialCtrl", require("./controllers/listTrialCtrl.js"));
mod.controller(
  "SingleClientCtrl",
  require("./controllers/singleClientCtrl.js")
);
mod.controller("AnalyticsCtrl", require("./controllers/analyticsCtrl.js"));

module.exports = mod;

},{"../../../package.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/package.json","./controllers/analyticsCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/clients/controllers/analyticsCtrl.js","./controllers/listClientCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/clients/controllers/listClientCtrl.js","./controllers/listTrialCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/clients/controllers/listTrialCtrl.js","./controllers/rest/clientAPI.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/clients/controllers/rest/clientAPI.js","./controllers/singleClientCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/clients/controllers/singleClientCtrl.js","./routes":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/clients/routes.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/clients/models/setStatus.js":[function(require,module,exports){
"use strict";

module.exports = {
  setClientStatus: setClientStatus,
  setTrialStatus: setTrialStatus,
  checkDate: checkDate
};

function setClientStatus(list) {
  _.forEach(list, function(elem) {
    if (elem.deactivated) {
      elem.status = "Deactivated";
    } else if (elem.permissions && elem.permissions.basic) {
      elem.status = "Paying";
    } else if (elem.freeExpDate) {
      elem.status = "Free User";
    } else if (elem.trial) {
      elem.status = "Trial User";
    } else {
      elem.status = "Expired";
    }
  });
  return list;
}

function setTrialStatus(list) {
  _.forEach(list, function(elem) {
    elem.status = checkDate(elem);
  });
  return list;
}

function checkDate(client) {
  var diff = moment().diff(moment(client.subscribedOn), "day");
  if (diff === 0) {
    //ignores the day the user subscribed on
    return 30;
  }
  if (diff > 30) {
    return "Expired";
  }
  return 30 - diff + 1;
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/clients/routes.js":[function(require,module,exports){
"use strict";

module.exports = routes;

routes.$inject = ["$stateProvider"];
function routes($stateProvider) {
  $stateProvider.state("index.clients", {
    templateUrl: "clients/views/listClients.html",
    url: "/clients",
    controller: "ListClientCtrl",
    controllerAs: "vm",
    resolve: {
      clients: listClients
    },
    data: {
      title: "Find Company",
      icon: "fa-building",
      menu: "Find Company"
    }
  });

  $stateProvider.state("index.trials", {
    templateUrl: "clients/views/listTrials.html",
    url: "/trials",
    controller: "ListTrialCtrl",
    controllerAs: "vm",
    resolve: {
      trialUsers: listTrials
    },
    data: {
      title: "Trial Users",
      icon: "fa-users",
      menu: "Trial Users"
    }
  });

  $stateProvider.state("index.clients.single", {
    templateUrl: "clients/views/formClient.html",
    url: "/data/:idClient",
    controller: "SingleClientCtrl",
    controllerAs: "vm",
    resolve: {
      client: getClient,
      summary: getSummary
    },
    data: {
      title: "Client data"
    }
  });

  $stateProvider.state("index.analytics", {
    templateUrl: "clients/views/analytics.html",
    url: "/analytics",
    controller: "AnalyticsCtrl",
    controllerAs: "vm",
    resolve: {
      clients: listClients
    },
    data: {
      title: "Analytics",
      icon: "fa-line-chart",
      menu: "Analytics"
    }
  });

  listClients.$inject = ["ClientAPI"];
  /**
   * Lists all system clients
   * @param  {Class} ClientAPI
   * @return {Array} Client List
   */
  function listClients(ClientAPI) {
    return ClientAPI.list();
  }

  /**
   * Lists all Trial clients
   * @param  {Class} ClientAPI
   * @return {Array} Trial Clients
   */
  listTrials.$inject = ["ClientAPI"];
  function listTrials(ClientAPI) {
    return ClientAPI.listBy("trial", true);
  }

  /**
   * Returns all client data
   * @param  {Class} ClientAPI
   * @param  {Object} $stateParams Params
   * @return {Object} Client Data
   */
  getClient.$inject = ["ClientAPI", "$stateParams"];
  function getClient(ClientAPI, $stateParams) {
    return ClientAPI.get($stateParams.idClient).then(function(client) {
      if (client.trial) {
        client.remainingDays = require("./models/setStatus.js").checkDate(
          client
        );
      }
      return client;
    });
  }

  /**
   * Fetches client summary information
   * @param  {} ClientAPI
   * @param  {} $stateParams Params
   * @param  {} cfpLoadingBar
   */
  getSummary.$inject = ["ClientAPI", "$stateParams", "cfpLoadingBar"];
  function getSummary(ClientAPI, $stateParams, cfpLoadingBar) {
    cfpLoadingBar.start();
    return ClientAPI.getSummary($stateParams.idClient).then(function(data) {
      cfpLoadingBar.complete();
      return data;
    });
  }
}

},{"./models/setStatus.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/clients/models/setStatus.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/customers/controllers/rest/customerAPI.js":[function(require,module,exports){
"use strict";

module.exports = CustomerAPI;

CustomerAPI.$inject = [
  "urlApi",
  "$firebaseArray",
  "$firebaseObject",
  "Notifications",
  "$http",
  "urlNode",
  "$q",
  "$sessionStorage"
];

function CustomerAPI(
  urlApi,
  $firebaseArray,
  $firebaseObject,
  Notifications,
  $http,
  urlNode,
  $q,
  $sessionStorage
) {
  var rootRef = new Firebase(urlApi);
  var customerRef = rootRef.child("Customer");
  CustomerAPI.listByClient = listByClient;
  CustomerAPI.saveCustomReportCustomer = saveCustomReportCustomer;
  CustomerAPI.removeCustomReportCustomer = removeCustomReportCustomer;
  return CustomerAPI;

  /**
   * Returns all customers from a client
   * @param  {String} clientId Client Id
   * @return {Array} Customer List
   */
  function listByClient(clientId) {
    var query = customerRef.child(clientId);
    return $firebaseArray(query).$loaded(function(resp) {
      return resp;
    });
  }

  /**
   * Assigns the custom report id to a specific customer from a client
   *
   * @param  {String} reportId Report Id
   * @param  {String} clientId Client Id
   * @param  {String} customerId Customer Id
   * @return {String} Customer Id
   */
  function saveCustomReportCustomer(reportId, clientId, customerId) {
    var query = customerRef.child(clientId).child(customerId);

    return $firebaseObject(query).$loaded(function(data) {
      if (!data.customReports) {
        data.customReports = [];
      }

      data.customReports.push(reportId);
      data.$save();
      return customerId;
    });
  }

  /**
   * Unassigns a custom report from a customer
   *
   * @param  {String} reportId Id Report
   * @param  {String} clientId Id Client
   * @param  {String} customerId Id Customer
   */
  function removeCustomReportCustomer(reportId, clientId, customerId) {
    var query = customerRef.child(clientId).child(customerId);
    return $firebaseObject(query).$loaded(function(data) {
      if (data.customReports) {
        var index = data.customReports.indexOf(reportId);
        if (index > -1) {
          data.customReports.splice(index, 1);
          data.$save();
        }
      }
    });
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/customreports/controllers/customReportCtrl.js":[function(require,module,exports){
"use strict";

module.exports = CustomReportCtrl;

CustomReportCtrl.$inject = [
  "$scope",
  "$state",
  "$stateParams",
  "Notifications",
  "cfpLoadingBar",
  "ReportAPI",
  "$timeout",
  "$uibModal",
  "ClientAPI",
  "$rootScope",
  "CustomerAPI",
  "$http",
  "urlNode",
  "FileUploader",
  "$q"
];

function CustomReportCtrl(
  $scope,
  $state,
  $stateParams,
  Notifications,
  cfpLoadingBar,
  ReportAPI,
  $timeout,
  $uibModal,
  ClientAPI,
  $rootScope,
  CustomerAPI,
  $http,
  urlNode,
  FileUploader,
  $q
) {
  var cr = this;
  cr.modelOptions = {};
  cr.report = {};
  cr.clients = {};
  cr.reportId = null;
  cr.searchText = "";
  cr.repCustomers = [];
  cr.customers = [];
  var FileSaver = require("file-saver");
  cr.types = [
    "Alarm",
    "Back Flow",
    "Emergency Exit",
    "Extinguisher",
    "Fire Hydrant",
    "Fire Pump",
    "Grease Cleaning",
    "Hood System",
    "Monitoring",
    "Sensitivity",
    "Special Hazard",
    "Sprinkler",
    "Standpipe Hose",
    "Suppression"
  ];

  cr.removeCustomReport = removeCustomReport;
  cr.saveCustomReport = saveCustomReport;
  cr.newCustomQuestion = newCustomQuestion;
  cr.openClientsModal = openClientsModal;
  cr.getClients = getClients;
  cr.openCustomersModal = openCustomersModal;
  cr.isCustomerInReport = isCustomerInReport;
  cr.assignCustomer = assignCustomer;
  cr.newMultipleChoice = newMultipleChoice;
  cr.newListQuestion = newListQuestion;
  cr.deleteChoice = deleteChoice;
  cr.deleteTypeListQuest = deleteTypeListQuest;
  cr.validQuestion = validQuestion;
  cr.addSection = addSection;
  cr.assignAllCustomers = assignAllCustomers;
  cr.unassignAllCustomers = unassignAllCustomers;
  cr.newQuestion = newQuestion;

  if ($stateParams.report) {
    getCustomReport();
  } else {
    cr.report.sections = [];
    cr.report.sections.push("default");
  }

  getCustomReports();
  getClients();

  //Initialize
  cr.uploader = new FileUploader({
    url: urlNode + "api/reports/savepdf",
    onCompleteAll: function(fileItem) {
      $state.go("index.custom-reports", {});
    },
    onErrorItem: function(fileItem) {
      alert("Error uploading the file");
    }
  });

  //Initialize
  cr.uploaderList = new FileUploader({
    url: urlNode + "api/reports/uploadList",
    onCompleteAll: function(fileItem) {
      /* cr.uploader.url = urlNode + "api/reports/savepdf/" + resp;
      cr.uploader.queue[0].url = urlNode + "api/reports/savepdf/" + resp;

      cr.uploader.uploadAll();*/
      // $state.go("index.custom-reports", {});
    },
    onErrorItem: function(fileItem) {
      alert("Error uploading the file");
    },
    onAfterAddingFile: function(fileItem, options) {
      console.log(fileItem);
      cr.changePDF = true;
    },
    onBeforeUploadItem: function(fileItem, options) {
      console.log(fileItem);
    }
  });

  // ui-sortable functions helper

  $scope.open = function(g) {
    if (g.open) g.open = false;
    else g.open = true;
    return g.open;
  };

  $scope.sortableOptions = {
    update: function(e, ui) {},
    stop: function(e, ui) {}
  };

  // ------------------ Custom Reports ------------------------------
  /**
   * Reads report from $stateparams and saves it on cr.report
   */
  function getCustomReport() {
    return ReportAPI.getCustomReport($stateParams.report).then(function(data) {
      //Initializes custom reports variables from data on firebase
      cr.report.id = data.$id;
      cr.report.name = data.name;
      cr.report.createdAt = data.createdAt;
      cr.report.frequency = data.frequency;
      cr.report.type = data.type;
      cr.report.pdfPath = data.pdfPath ? data.pdfPath : null;
      cr.report.AES1CoverSheet = data.AES1CoverSheet;
      cr.report.pdf = data.pdf;

      //We always create a default section if there are none
      if (!data.sections) {
        cr.report.sections = [];
        cr.report.sections.push("default");
      } else {
        cr.report.sections = data.sections;

        var defaultSection = false;
        for (var i = 0; i < cr.report.sections.length && !defaultSection; i++) {
          if (cr.report.sections[i] === "default") {
            defaultSection = true;
          }
        }

        if (!defaultSection) {
          cr.report.sections.splice(0, 0, "default");
        }
      }

      //Custom questions array initialization
      if (!data.questions) {
        cr.report.customQuestions = [];
      } else {
        cr.report.customQuestions = data.questions;
      }

      //Assigned clients array initialization
      if (!data.clients) {
        cr.report.clients = [];
      } else {
        cr.report.clients = data.clients;
      }
    });
  }

  /**
   * Retrieves all custom reports
   */
  function getCustomReports() {
    cfpLoadingBar.start();
    return ReportAPI.getCustomReports().then(function(resp) {
      cr.customReports = resp;
      cfpLoadingBar.complete();
    });
  }

  /**
   * Deletes selected report
   * @param  {String} customReportId
   */
  function removeCustomReport(customReportId) {
    if (confirm("Are you sure you want to delete this report?")) {
      ReportAPI.removeCustomReport(customReportId);
    }
  }

  /**
   * Helper function that deletes empty sections
   */
  function okSections() {
    if (cr.report.sections) {
      for (var i = cr.report.sections.length - 1; i >= 0; i--) {
        var found = false;
        for (var j = 0; j < cr.report.customQuestions.length && !found; j++) {
          if (cr.report.customQuestions[j].section === cr.report.sections[i]) {
            found = true;
          }
        }

        if (!found) {
          cr.report.sections.splice(i, 1);
        }
      }
    }
  }

  /**
   * Saves custom report in firebase.
   * Verifies that all inserted values are complete and correct
   * Upload pdf files to server
   */
  function saveCustomReport() {
    var completeQuestions = verifyCustomQuestions();
    var okPdfFile = isValidPdf();

    //checks all values are completed
    if (
      cr.report.name &&
      cr.report.customQuestions &&
      cr.report.type &&
      completeQuestions &&
      okPdfFile.length === 0
    ) {
      okSections();
      var obj = {
        id: cr.report.id ? cr.report.id : null,
        createdAt: moment().format("YYYY-MM-DD"),
        name: cr.report.name,
        type: cr.report.type,
        questions: cr.report.customQuestions,
        sections: cr.report.sections,
        AES1CoverSheet: cr.report.AES1CoverSheet
      };

      //saves the data on firebase and uploads the files to backend
      ReportAPI.save(obj).then(function(resp) {
        if (cr.changePDF) {
          cr.uploaderList.url = urlNode + "api/reports/uploadList/" + resp;
          console.log(cr.uploaderList.queue);

          for (var i = 0; i < cr.uploaderList.queue.length; i++) {
            cr.uploaderList.queue[i].url =
              urlNode +
              "api/reports/uploadList/" +
              resp +
              "?idQuestion=" +
              cr.uploaderList.queue[i].idQuestion;
            ReportAPI.addListPdfToReport(cr.report.id, cr.uploaderList.queue[i].idQuestion);
          }

          cr.uploaderList.uploadAll();

          if (cr.uploader.queue.length)
          {
            cr.uploader.url = urlNode + "api/reports/savepdf/" + resp;
            cr.uploader.queue[0].url = urlNode + "api/reports/savepdf/" + resp;
  
            cr.uploader.uploadAll();
            ReportAPI.addPdfToReport(cr.report.id);
          }
        }
      });
    } else if (!cr.report.name) {
      alert("Report name is empty. Please complete this field");
    } else if (!cr.report.type) {
      alert("Report type is empty. Please complete this field");
    } else if (
      !cr.report.customQuestions ||
      cr.report.customQuestions.length === 0
    ) {
      alert("There are no custom questions.");
    } else if (okPdfFile.length > 0) {
      alert(okPdfFile);
    } else {
      alert(
        "Some questions are incompleted. Please complete all question fields. "
      );
    }
  }

  /**
   * Another file upload function / not used
   * @param  {} file
   * @param  {} resp
   */
  function upload(file, resp) {
    ngFileUpload.Upload.upload({
      url: urlNode + "api/report/savepdf/" + resp, //webAPI exposed to upload the file
      data: { file: file } //pass file as data, should be user ng-model
    }).then(
      function(resp) {
        //upload function returns a promise
        if (resp.data.error_code === 0) {
          //validate success
          $window.alert(
            "Success " + resp.config.data.file.name + "uploaded. Response: "
          );
          $state.go("index.custom-reports", {});
        } else {
          $window.alert("an error occured");
        }
      },
      function(resp) {
        //catch error
        console.log("Error status: " + resp.status);
        $window.alert("Error status: " + resp.status);
      },
      function(evt) {
        console.log(evt);
        var progressPercentage = parseInt((100.0 * evt.loaded) / evt.total);
        console.log(
          "progress: " + progressPercentage + "% " + evt.config.data.file.name
        );
        vm.progress = "progress: " + progressPercentage + "% "; // capture upload progress
      }
    );
  }

  /**
   * Verifies completed and correct questions.
   */
  function verifyCustomQuestions() {
    if (!cr.report.customQuestions || cr.report.customQuestions.length === 0) {
      return false;
    } else {
      //Check if questions are completed depending on their question type
      var ok = true;
      for (var i = 0; i < cr.report.customQuestions.length && ok; i++) {
        var question = cr.report.customQuestions[i];

        if (
          !question.title ||
          !question.questType ||
          (!question.idQuestion && question.questType !== "Multiple")
        ) {
          ok = false;
        }

        var multipleChoice =
          question.questType === "Multiple" || question.questType === "Select";

        if (multipleChoice) {
          deleteNotFilledInputs(question.choices, question.questType);

          if (!question.choices || question.choices.length === 0) {
            ok = false;
          }
          if (question.questType === "Multiple") {
            delete question.idQuestion;
          }
        } else if (question.questType === "List") {
          ok = validQuestion(question);

          if (!question.list || question.list.length === 0) {
            ok = false;
          }
        }

        if (!multipleChoice && question.choices) {
          delete question.choices;
        }
        if (question.questType !== "List" && question.list) {
          delete question.list;
        }
        if (!_.isUndefined(question.open)) {
          delete question.open;
        }
      }
    }

    return ok;
  }

  /**
   * Delete empty multiple choice or dropdown options
   * @param  {Object} item Choices
   * @param  {String} type Type of question
   */
  function deleteNotFilledInputs(item, type) {
    var notFill = [];
    _.forEach(item, function(elem) {
      if (type === "Multiple") {
        if (!elem.idQuestion || !elem.value) {
          notFill.push(elem);
        }
      } else {
        if (!elem.value) {
          notFill.push(elem);
        }
      }
    });
    _.forEach(notFill, function(elem) {
      var index = item.indexOf(elem);
      if (index > -1) {
        item.splice(index, 1);
      }
    });
  }

  /**
   * Creates new question with section as 'default'
   */
  function newCustomQuestion() {
    if (!cr.report.customQuestions) {
      cr.report.customQuestions = [];
    }
    cr.report.customQuestions.push({
      title: null,
      idQuestion: null,
      questType: null,
      section: "default"
    });
  }

  /**
   * Helper function to check pdf type file
   * @return {String} validation message
   */
  function isValidPdf() {
    console.log(document.getElementById("file").files);
    if (
      !cr.report.id &&
      (!document.getElementById("file").files[0] ||
        document.getElementById("file").files.length === 0)
    ) {
      return "Please upload a PDF file to continue";
    } else if (
      document.getElementById("file").files[0] ||
      document.getElementById("file").files.length !== 0
    ) {
      var filename = document.getElementById("file").files[0].name;

      if (filename.split(".").pop() !== "pdf") {
        return "Incorrect format, use pdf format";
      } else {
        cr.changePDF = true;
        return "";
      }
    }

    return "";
  }

  // ------------------ Clients ------------------------------

  /**
   * Opens modal to show all system clients. Allows to select one
   * After selecting one a list of all customers from that client will show up for selection
   * @param  {String} reportId Report Id
   */
  function openClientsModal(reportId) {
    cr.reportId = reportId;
    cfpLoadingBar.start();
    cr.modalInstanceClients = $uibModal.open({
      templateUrl: "customreports/views/modals/assignClientModal.html",
      scope: $scope
    });
    cfpLoadingBar.complete();

    cr.modalInstanceClients.result.then(
      function(close) {
        cr.searchText = "";
      },
      function(dismiss) {
        cr.searchText = "";
      }
    );
  }

  /**
   * Verifies if a customer is already assigned to a custom report
   * @param  {String} customerId Customer Id
   * @return {Boolean} True if it's assigned, false if not
   */
  function isCustomerInReport(customerId) {
    if (!cr.repCustomers) {
      return false;
    } else {
      var found = false;
      for (var i = 0; i < cr.repCustomers.length && !found; i++) {
        if (cr.repCustomers[i] === customerId) {
          found = true;
        }
      }
      if (!found) {
        var index = cr.noRepCustomers.indexOf(customerId);
        if (index === -1) {
          cr.noRepCustomers.push(customerId);
        }
      }
      return found;
    }
  }

  /**
   * Gets all clients
   */
  function getClients() {
    return ClientAPI.list().then(function(data) {
      cr.clients = data;
    });
  }

  /**
   * Assigns all customers to a report
   */
  function assignAllCustomers() {
    cfpLoadingBar.start();
    $timeout(function() {
      console.log(cr.noRepCustomers);
      var promises = [];
      ReportAPI.saveCustomReportCustomer(
        cr.reportId,
        cr.clientId,
        cr.noRepCustomers
      )
        .then(function(resp) {
          _.forEach(cr.noRepCustomers, function(customerId) {
            var promise = $q(function(resolve, reject) {
              CustomerAPI.saveCustomReportCustomer(
                cr.reportId,
                cr.clientId,
                customerId
              )
                .then(function(custId) {
                  cr.repCustomers.push(custId);
                  resolve();
                })
                .catch(function(exp) {
                  console.log(exp);
                  reject();
                });
            });
            promises.push(promise);
          });
        })
        .catch(function(exp) {
          console.log(exp);
          Notifications.addCustom(500, "Error, please try again.");
        });

      $q.all(promises)
        .then(function(data) {
          console.log("todas");
          Notifications.addCustom(200, "Report assigned successfully");
        })
        .catch(function(err) {
          Notifications.addCustom(500, "Error, please try again.");
        })
        .finally(function() {
          cfpLoadingBar.complete();
        });
    }, 100);
  }

  /**
   * Unassigns all customers from a report
   */
  function unassignAllCustomers() {
    cfpLoadingBar.start();
    $timeout(function() {
      var promises = [];
      ReportAPI.removeCustomReportCustomer(cr.reportId, cr.clientId)
        .then(function(resp) {
          for (var i = cr.repCustomers.length - 1; i >= 0; i--) {
            var promise = $q(function(resolve, reject) {
              CustomerAPI.removeCustomReportCustomer(
                cr.reportId,
                cr.clientId,
                cr.repCustomers[i]
              )
                .then(function(custId) {
                  var index = cr.repCustomers.indexOf(custId);
                  cr.repCustomers.splice(index, 1);
                  resolve();
                })
                .catch(function(exp) {
                  reject();
                });
            });
            promises.push(promise);
          }
        })
        .catch(function(exp) {
          console.log(exp);
          Notifications.addCustom(500, "Error, please try again.");
        });

      $q.all(promises)
        .then(function(data) {
          console.log("todas rem");
          Notifications.addCustom(200, "Report unassigned successfully");
        })
        .catch(function(err) {
          Notifications.addCustom(500, "Error, please try again.");
        })
        .finally(function() {
          cfpLoadingBar.complete();
        });
    }, 100);
  }

  /**
   * Assigns/Unassigns a customer from a report
   */
  function assignCustomer(customerId) {
    if (!isCustomerInReport(customerId)) {
      ReportAPI.saveCustomReportCustomer(cr.reportId, cr.clientId, customerId)
        .then(function(resp) {
          CustomerAPI.saveCustomReportCustomer(
            cr.reportId,
            cr.clientId,
            customerId
          )
            .then(function(resp) {
              cr.repCustomers.push(customerId);
              Notifications.addCustom(200, "Report assigned successfully");
            })
            .catch(function(exp) {
              Notifications.addCustom(500, "Error, please try again");
            });
        })
        .catch(function(exp) {
          Notifications.addCustom(500, "Error, please try again.");
        });
    } else {
      ReportAPI.removeCustomReportCustomer(
        cr.reportId,
        cr.clientId,
        customerId
      ).then(function(resp) {
        CustomerAPI.removeCustomReportCustomer(
          cr.reportId,
          cr.clientId,
          customerId
        )
          .then(function(resp) {
            var index = cr.repCustomers.indexOf(customerId);
            cr.repCustomers.splice(index, 1);
            Notifications.addCustom(
              200,
              "Customer removed from Report successfully"
            );
          })
          .catch(function(exp) {
            Notifications.addCustom(500, "Error, please try again.");
          });
      });
    }
  }

  /**
   * Opens a modal showing all customers from a client
   * @param  {String} clientId Client Id
   * @param  {String} clientName Title to show on modal
   */
  function openCustomersModal(clientId, clientName) {
    cfpLoadingBar.start();
    cr.searchText = "";
    cr.clientName = clientName;
    CustomerAPI.listByClient(clientId)
      .then(function(data) {
        cr.customers = data;
        cr.clientId = clientId;
        ReportAPI.getCustomReport(cr.reportId).then(function(data) {
          cr.repCustomers = [];
          cr.noRepCustomers = [];
          if (data.clients) {
            for (
              var i = 0;
              i < data.clients.length && cr.repCustomers.length === 0;
              i++
            ) {
              if (data.clients[i].clientId === clientId) {
                cr.repCustomers = data.clients[i].customers;
              }
            }
          }
          cfpLoadingBar.complete();

          cr.modalInstanceCustomers = $uibModal.open({
            templateUrl: "customreports/views/modals/assignCustomerModal.html",
            scope: $scope
          });

          cr.modalInstanceCustomers.result.then(
            function(close) {
              cr.searchText = "";
            },
            function(dismiss) {
              cr.searchText = "";
            }
          );
        });
      })
      .catch(function(err) {
        cfpLoadingBar.complete();
        Notifications.addCustom(500, "Error, please try again.");
      });
  }

  /**
   * Creates a new multiple choice option
   * @param  {Object} question Custom Question
   */
  function newMultipleChoice(question) {
    if (!question.choices) {
      question.choices = [];
    }

    question.choices.push({ value: "" });
  }

  /**
   * Creates a new question for the list custom question
   * In other words, creates the equivalent to a column on pdf
   * @param  {Object} question question.type === 'List'
   */
  function newListQuestion(question) {
    if (!question.list) {
      question.list = [];
    }

    question.list.push({
      title: "",
      idQuestion: null,
      questType: null
    });
  }

  /**
   * Same as newListQuestion but for static questions not repeatable
   * @param  {Object} question question.type === 'List'
   */
  function newQuestion(question) {
    if (!question.otherList) {
      question.otherList = [];
    }

    question.otherList.push({
      title: "",
      idQuestion: null,
      questType: null,
      other: true
    });
  }

  /**
   * Deletes an option from choices
   * @param  {Object} question question.type === 'Select' || question.type === 'Multiple'
   * @param  {String} choice option to delete
   */
  function deleteChoice(question, choice) {
    var index = question.choices.indexOf(choice);
    question.choices.splice(index, 1);
  }

  /**
   * Deletes a custom question of list type
   * @param  {Object} question question.type === 'List'
   * @param  {Object} item Question to delete
   */
  function deleteTypeListQuest(question, item) {
    if (item.other) {
      var index = question.otherList.indexOf(item);
      question.otherList.splice(index, 1);
    } else {
      var index = question.list.indexOf(item);
      question.list.splice(index, 1);
    }
  }

  /**
   * Verifies a question has all valid fields
   * @param  {Object} question Custom Question
   * @return {Boolean} True if valid
   */
  function validQuestion(question) {
    if (!question.title || !question.questType) {
      return false;
    } else if (!question.idQuestion && question.questType !== "Multiple") {
      return false;
    } else {
      if (question.questType === "Select") {
        return validateValues(question.choices);
      } else if (question.questType === "List") {
        return (
          completeListValues(question.list, "List") &&
          completeListValues(question.otherList, "OtherList")
        );
      } else if (question.questType === "Multiple") {
        return validateValues(question.choices, "Multiple");
      } else {
        return true;
      }
    }
  }

  /**
   * Helper function for validQuestion() for list type questions
   *
   * @param  {Object} items question && question.type == 'List'
   * @param  {String} type
   */
  function completeListValues(items, type) {
    if (!items || items.length == 0) {
      if (type === "OtherList") {
        return true;
      } else {
        return false;
      }
    } else {
      var ok = true;
      for (var i = 0; i < items.length && ok; i++) {
        if ((!items[i].idQuestion && items[i].questType !== "Multiple") 
            || !items[i].title || !items[i].questType) {
          ok = false;
        } else if (items[i].questType === "Select" || items[i].questType === "Multiple") {
          ok = items[i].choices && items[i].choices.length > 0;
        }
      }
      return ok;
    }
  }

  /**
   * Helper function for validQuestion() for multiple or select questions
   *
   * @param  {Object} items question
   * @param  {String} type (Multiple o Dropdown)
   */
  function validateValues(items, type) {
    if (!items || items.length == 0) {
      return false;
    } else {
      var ok = false;
      for (var i = 0; i < items.length && !ok; i++) {
        if (type === "Multiple") {
          if (items[i].idQuestion && items[i].value) {
            ok = true;
          }
        } else {
          if (items[i].value) {
            ok = true;
          }
        }
      }
      return ok;
    }
  }

  /**
   * Add a new section for the report and adds its to the specific question
   * @param  {Object} question Custom Question
   * @param  {Number} index aux for id input.
   */
  function addSection(question, index) {
    if (!cr.report.sections) {
      cr.report.sections = [];
    }

    var value = document.getElementById("section" + index).value;
    if (value) {
      cr.report.sections.push(value);
      question.section = value;
    }
  }
}

},{"file-saver":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/node_modules/file-saver/FileSaver.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/customreports/controllers/rest/reportAPI.js":[function(require,module,exports){
"use strict";

module.exports = ReportAPI;

ReportAPI.$inject = [
  "urlApi",
  "$firebaseArray",
  "$firebaseObject",
  "ClientAPI",
  "Notifications",
  "$http",
  "urlNode",
  "$q",
  "$sessionStorage",
  "$stateParams",
  "CustomerAPI"
];

function ReportAPI(
  urlApi,
  $firebaseArray,
  $firebaseObject,
  ClientAPI,
  Notifications,
  $http,
  urlNode,
  $q,
  $sessionStorage,
  $stateParams,
  CustomerAPI
) {
  var ref = new Firebase(urlApi);

  ReportAPI.save = save;
  ReportAPI.getCustomReports = getCustomReports;
  ReportAPI.removeCustomReport = removeCustomReport;
  ReportAPI.getCustomReport = getCustomReport;
  ReportAPI.saveCustomReportCustomer = saveCustomReportCustomer;
  ReportAPI.removeCustomReportCustomer = removeCustomReportCustomer;
  ReportAPI.addPdfToReport = addPdfToReport;
  ReportAPI.addListPdfToReport = addListPdfToReport;
  return ReportAPI;

  /**
   * Saves custom report on firebase
   *
   * @param  {Object} obj Custom Report
   */
  function save(obj) {
    if (obj.id) {
      return edit(obj);
    } else {
      return create(obj);
    }
  }

  /**
   * Helper function for save, creates a new one
   * @param  {Object} obj Custom Report
   * @return {String} Report Id
   */
  function create(obj) {
    var query = ref.child("ReportTemplate");

    return $firebaseArray(query)
      .$add(obj)
      .then(ok);

    function ok(resp) {
      Notifications.addCustom(200, "Custom Report created successfully");
      return resp.key();
    }
  }

  /**
   * Helper function for save, edits existing one
   *
   * @param  {Object} obj Custom Report
   */
  function edit(obj) {
    var query = ref.child("ReportTemplate").child(obj.id);

    return $firebaseObject(query).$loaded(function(data) {
      data.name = obj.name;
      data.questions = obj.questions;
      data.type = obj.type;
      data.sections = obj.sections;
      data.AES1CoverSheet = obj.AES1CoverSheet;
      data.$save();
      return data.$id;
    });
  }

  /**
   * Recovers existing custom reports
   * @return {Array} Custom reports list
   */
  function getCustomReports() {
    var query = ref.child("ReportTemplate");

    return $firebaseArray(query).$loaded(function(data) {
      return data;
    });
  }

  /**
   * Recovers specific custom report
   *
   * @param  {String} reportId Report Id
   * @return {type} firebase response
   */
  function getCustomReport(reportId) {
    var query = ref.child("ReportTemplate").child(reportId);

    return $firebaseObject(query).$loaded(function(data) {
      return data;
    });
  }

  /**
   * Deletes a report and unassigns all customers
   * @param  {} reportId
   */
  function removeCustomReport(reportId) {
    getCustomReport(reportId).then(function(report) {
      if (report.clients) {
        var clients = report.clients;
        for (var i = 0; i < clients.length; i++) {
          var customers = report.clients[i].customers;
          for (var j = 0; j < customers.length; j++) {
            CustomerAPI.removeCustomReportCustomer(
              reportId,
              clients[i].clientId,
              customers[j]
            )
              .then(function(resp) {})
              .catch(function(exp) {
                Notifications.addCustom(500, "Error, please try again.");
              });
          }
        }
      }

      var reportRef = ref.child("ReportTemplate").child(reportId);

      return reportRef.remove(function(err) {
        if (err) {
          Notifications.addCustom(500, "There was a problem.");
          return err;
        } else {
          Notifications.addCustom(200, "Report deleted successfully");
          return true;
        }
      });
    });
  }

  /**
   * Assigns a report to one or many customers
   * @param  {String} reportId Id report
   * @param  {String} clientId Id client
   * @param  {Array/Object} customer List with one or many customers
   */
  function saveCustomReportCustomer(reportId, clientId, customer) {
    var query = ref.child("ReportTemplate").child(reportId);
    return $firebaseObject(query).$loaded(function(data) {
      var save = false;
      if (!data.clients) {
        data.clients = [];
      } else {
        for (var i = 0; i < data.clients.length && !save; i++) {
          if (data.clients[i].clientId === clientId) {
            if (!data.clients[i].customers) data.clients[i].customers = [];

            if (angular.isArray(customer)) {
              data.clients[i].customers = data.clients[i].customers.concat(
                customer
              );
            } else {
              data.clients[i].customers.push(customer);
            }
            save = true;
          }
        }
      }
      if (!save) {
        var customers = [];
        if (angular.isArray(customer)) {
          customers = customer;
        } else {
          customers.push(customer);
        }

        data.clients.push({
          clientId: clientId,
          customers: customers
        });
      }
      data.$save();
      return customer;
    });
  }

  /**
   * Assigns a report to one or many customers
   * @param  {String} reportId Id report
   * @param  {String} clientId Id client
   * @param  {Array/Object} customer Customers id, if empty deletes all
   */
  function removeCustomReportCustomer(reportId, clientId, customerId = null) {
    var query = ref.child("ReportTemplate").child(reportId);

    return $firebaseObject(query).$loaded(function(data) {
      if (data.clients) {
        for (var i = 0; i < data.clients.length; i++) {
          if (data.clients[i].clientId == clientId) {
            if (!customerId) {
              delete data.clients[i].customers;
              delete data.clients[i].clientId;
            } else {
              var index = data.clients[i].customers.indexOf(customerId);
              if (index > -1) {
                data.clients[i].customers.splice(index, 1);
              }
            }
          }
        }
        data.$save();
      }
    });
  }

  function addPdfToReport(reportId) {
    var query = ref.child("ReportTemplate").child(reportId);

    return $firebaseObject(query).$loaded(function(data) {
      data.pdf = reportId;
      data.$save();
    })
  }

  function addListPdfToReport(reportId, listName) {
    var query = ref.child("ReportTemplate").child(reportId);

    return $firebaseObject(query).$loaded(function(data) {
      var question = _.find(data.questions, { idQuestion: listName });
      question.pdf = reportId + '_' + listName;
      data.$save();
    })
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/customreports/index.js":[function(require,module,exports){
"use strict";

var _name = require("../../../package.json").name;

var mod = angular.module(_name + ".customReports", []);

mod.config(require("./routes"));

mod.factory("ReportAPI", require("./controllers/rest/reportAPI.js"));
mod.factory("ClientAPI", require("../clients/controllers/rest/clientAPI.js"));
mod.factory(
  "CustomerAPI",
  require("../customers/controllers/rest/customerAPI.js")
);

mod.controller(
  "CustomReportCtrl",
  require("./controllers/customReportCtrl.js")
);

module.exports = mod;

},{"../../../package.json":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/package.json","../clients/controllers/rest/clientAPI.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/clients/controllers/rest/clientAPI.js","../customers/controllers/rest/customerAPI.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/customers/controllers/rest/customerAPI.js","./controllers/customReportCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/customreports/controllers/customReportCtrl.js","./controllers/rest/reportAPI.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/customreports/controllers/rest/reportAPI.js","./routes":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/customreports/routes.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/customreports/routes.js":[function(require,module,exports){
"use strict";

module.exports = routes;

routes.$inject = ["$stateProvider"];
function routes($stateProvider) {
  $stateProvider.state("index.custom-reports", {
    templateUrl: "customreports/views/customReports.html",
    url: "/customreports",
    controller: "CustomReportCtrl",
    controllerAs: "cr",
    data: {
      title: "Custom Reports",
      icon: "fa-edit",
      menu: "Custom Reports"
    }
  });

  $stateProvider.state("index.start-custom-report", {
    templateUrl: "customreports/views/customReportSingle.html",
    url: "/customreports/template/:report",
    controller: "CustomReportCtrl",
    controllerAs: "cr",
    data: {
      title: "New Custom Report",
      icon: "fa-edit",
      menu: "New Custom Report",
      hidden: true
    },
    params: {
      report: null
    }
  });
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/login/controllers/login.js":[function(require,module,exports){
"use strict";

module.exports = LoginCtrl;

LoginCtrl.$inject = [
  "$auth",
  "Notifications",
  "$state",
  "$sessionStorage",
  "$localStorage",
  "UserAPI",
  "cfpLoadingBar"
];

function LoginCtrl(
  $auth,
  Notifications,
  $state,
  $sessionStorage,
  $localStorage,
  UserAPI,
  cfpLoadingBar
) {
  var vm = this;
  vm.login = login;
  vm.user = {
    remember: true
  };
  vm.reset = false;
  vm.submitEmail = submitEmail;

  /**
   * User Login
   * @param  {Object} form
   * @param  {Object} user
   */
  function login(form, user) {
    if (form.$valid) {
      var remember = !vm.user.remember ? "sessionOnly" : "default";
      cfpLoadingBar.start();
      UserAPI.login(user.login, user.password, remember)(result);
    } else {
      return Notifications.addCustom(400, "Required information missing ");
    }
  }

  /**
   * Password reset
   * @param  {Object} form
   * @param  {String} email
   */
  function submitEmail(form, email) {
    if (form.$valid) {
      cfpLoadingBar.start();
      UserAPI.resetPassword(email).then(closeLB, closeLB);
    }
  }

  /**
   * Helper function to close loading bar modal
   */
  function closeLB() {
    cfpLoadingBar.complete();
  }

  /**
   * Logic for after login in according to permissions
   * @param  {Response} error
   * @param  {Object} data
   */
  function result(error, data) {
    if (error) {
      cfpLoadingBar.complete();
      Notifications.addCustom(400, "Invalid Credentials");
    } else {
      UserAPI.isAdmin(data.uid).then(function(user) {
        if (user.exists()) {
          var userVal = user.val();

          userVal.onlyCustomReports = userVal.onlyCustomReports
            ? userVal.onlyCustomReports
            : false;

          var session = {
            token: data.token,
            email: vm.user.login,
            onlyCustomReports: userVal.onlyCustomReports
          };

          $sessionStorage.user = session;
          $localStorage.user = session;
          if (vm.user.remember === true) {
            $localStorage.user = session;
          }
          if (userVal.onlyCustomReports) {
            $state.go("index.custom-reports").then(function() {
              //document.body.scrollTop = 0;
              cfpLoadingBar.complete();
            });
          } else {
            $state.go("index.clients").then(function() {
              // document.body.scrollTop = 0;
              cfpLoadingBar.complete();
            });
          }
        } else {
          $auth.logout().then(function() {
            $state.go("login");
            Notifications.addCustom(
              400,
              "You don't have permission to access this site"
            );
            cfpLoadingBar.complete();
          });
        }
      });
    }
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/login/controllers/rest/userAPI.js":[function(require,module,exports){
"use strict";

module.exports = UserAPI;

UserAPI.$inject = ["urlApi", "Notifications", "$q", "urlNode", "$http"];
function UserAPI(urlApi, Notifications, $q, urlNode, $http) {
  var ref = new Firebase(urlApi);
  UserAPI.login = login;
  UserAPI.createAccount = createAccount;
  UserAPI.changePassword = changePassword;
  UserAPI.resetPassword = resetPassword;
  UserAPI.removeUser = removeUser;
  UserAPI.isAdmin = isAdmin;
  UserAPI.deactivate = deactivate;
  UserAPI.activate = activate;
  return UserAPI;

  /**
   * User Login
   * @param  {String} email
   * @param  {String} password
   * @param  {String} remember
   */
  function login(email, password, remember) {
    return function(callback) {
      var url = urlNode + "api/auth/login";
      $http.post(url, { email, password }).then(
        function(res) {
          callback(null, res.data);
        },
        function(err) {
          callback(err, null);
        }
      );
    };
  }

  /**
   * Account creation
   * @param  {Object} credentials
   */
  function createAccount(credentials) {
    var future = $q.defer();
    return ref.createUser(
      {
        email: credentials.email || "",
        password: credentials.password
      },
      function(error, userData) {
        if (error) {
          switch (error.code) {
            case "EMAIL_TAKEN":
              Notifications.addCustom(400, "The email is already in use.");
              break;
            case "INVALID_EMAIL":
              Notifications.addCustom(
                400,
                "The specified email is not a valid email."
              );
              break;
            default:
              Notifications.addCustom(500, "Error creating user: ", error);
          }
          future.reject(error);
        } else {
          Notifications.addCustom(
            200,
            "Customer account successfully created."
          );
          future.resolve(userData);
        }
        return future.promise;
      }
    );
  }

  /**
   * Password change
   * @param  {Object} credentials
   */
  function changePassword(credentials) {
    var future = $q.defer();
    return ref.changePassword(
      {
        email: credentials.email,
        oldPassword: credentials.oldPassword,
        newPassword: credentials.newPassword
      },
      function(error) {
        if (error) {
          switch (error.code) {
            case "INVALID_PASSWORD":
              Notifications.addCustom(400, "The user password is incorrect.");
              break;
            case "INVALID_USER":
              Notifications.addCustom(400, "The specified user doesn't exist");
              break;
            default:
              Notifications.addCustom(500, "Error changing password: " + error);
          }
          future.reject(error.code);
        } else {
          Notifications.addCustom(200, "User password changed successfully!");
          future.resolve(true);
        }
        return future.promise;
      }
    );
  }

  /**
   * Resets password
   * @param  {String} email
   */
  function resetPassword(email) {
    var future = $q.defer();
    return ref.resetPassword(
      {
        email: email
      },
      function(error) {
        if (!error) {
          Notifications.addCustom(
            200,
            "Password reset email sent successfully"
          );
          future.reject(error);
        } else {
          Notifications.addCustom(
            500,
            "Error sending password reset email: " + error
          );
          future.resolve(true);
        }
        return future.promise;
      }
    );
  }

  /**
   * Deletes user
   * @param  {Object} credentials
   */
  function removeUser(credentials) {
    var future = $q.defer();
    return ref.removeUser(
      {
        email: credentials.email,
        password: credentials.password
      },
      function(error) {
        if (error) {
          switch (error.code) {
            case "INVALID_USER":
              Notifications.addCustom(
                400,
                "The specified user account does not exist."
              );
              break;
            case "INVALID_PASSWORD":
              Notifications.addCustom(
                400,
                "The specified user account password is incorrect."
              );
              break;
            default:
              Notifications.addCustom(500, "Error removing user: " + error);
          }
          future.reject(error.code);
        } else {
          Notifications.addCustom(200, "User account deleted successfully!");
          future.resolve(true);
        }
        return future.promise;
      }
    );
  }

  /**
   * Check if user is admin and is able to use backoffice
   * Basically controls that it's and admin user and not any other normal user
   * @param  {} uid
   */
  function isAdmin(uid) {
    var dashboardRef = ref.child("Dashboard").child(uid);
    return dashboardRef.once("value", function(snapshot) {
      return snapshot;
    });
  }

  /**
   * Desactives a client
   * @param  {Object} client
   */
  function deactivate(client) {
    return ref
      .child("BlockedUsers")
      .child(client.$id)
      .set(true, function(error) {
        if (!error) {
          client.deactivated = true;
          return client.$save().then(function() {
            return Notifications.addCustom(
              200,
              "Client account was deactivated."
            );
          });
        }
      });
  }

  /**
   * Activates a client
   * @param  {Object} client
   */
  function activate(client) {
    return ref
      .child("BlockedUsers")
      .child(client.$id)
      .remove(function(error) {
        if (!error) {
          delete client.deactivated;
          delete client.deactivationDate;
          return client.$save().then(function() {
            return Notifications.addCustom(
              200,
              "Client account was reactivated."
            );
          });
        }
      });
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/login/index.js":[function(require,module,exports){
"use strict";

var mod = angular.module("BaseProject.login", []);

mod.config(require("./routes"));

mod.controller("LoginCtrl", require("./controllers/login.js"));

mod.factory("UserAPI", require("./controllers/rest/userAPI.js"));

module.exports = mod;

},{"./controllers/login.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/login/controllers/login.js","./controllers/rest/userAPI.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/login/controllers/rest/userAPI.js","./routes":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/login/routes.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/login/routes.js":[function(require,module,exports){
"use strict";

module.exports = routes;
routes.$inject = ["$stateProvider"];

function routes($stateProvider) {
  $stateProvider.state("login", {
    url: "/",
    templateUrl: "login/views/login.html",
    controller: "LoginCtrl",
    controllerAs: "vm",
    free: true
  });
} //routes

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/main/controllers/mainCtrl.js":[function(require,module,exports){
"use strict";

module.exports = MainCtrl;

MainCtrl.$inject = [];
function MainCtrl() {
  var mod = this;
  mod.currentDate = moment();
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/main/controllers/rest/emailAPI.js":[function(require,module,exports){
"use strict";

module.exports = EmailAPI;

EmailAPI.$inject = ["Notifications", "$sessionStorage", "$http", "urlNode"];

function EmailAPI(Notifications, $sessionStorage, $http, urlNode) {
  var ref = urlNode + "api/email";
  EmailAPI.sendEmail = sendEmail;
  return EmailAPI;

  /**
   * Sends email
   * @param  {Object} emailData Email Data
   * @return {String} Response
   */
  function sendEmail(emailData) {
    return $http.post(ref, emailData).then(
      function(resp) {
        Notifications.addCustom(
          resp.status,
          "Email has been sent successfully."
        );
        return resp;
      },
      function(err) {
        Notifications.addCustom(
          err.status,
          _.get(err.data, "message", "Email could not be sent.")
        );
        return err;
      }
    );
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/main/index.js":[function(require,module,exports){
"use strict";

var mod = angular.module("BaseProject.Main", []);
mod.config(require("./routes"));

mod.controller("MainCtrl", require("./controllers/mainCtrl.js"));
mod.factory("EmailAPI", require("./controllers/rest/emailAPI.js"));

module.exports = mod;

},{"./controllers/mainCtrl.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/main/controllers/mainCtrl.js","./controllers/rest/emailAPI.js":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/main/controllers/rest/emailAPI.js","./routes":"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/main/routes.js"}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/main/routes.js":[function(require,module,exports){
"use strict";

module.exports = routes;

routes.$inject = ["$stateProvider"];
function routes($stateProvider) {}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/app/stateChange.js":[function(require,module,exports){
"use strict";

module.exports = stateChange;

function stateChange(
  $auth,
  $localStorage,
  $sessionStorage,
  Notifications,
  $state,
  $http
) {
  return function(event, toState) {
    if ($auth.isAuthenticated()) {
      avoidLoginScreen(event, toState);
      headerOdoo();
      logoutFromAnotherPlace(event);
    } else {
      if ($localStorage.user) {
        loginByRemember(event);
      } else {
        withoutLogin(event, toState);
      }
    }
  };

  /**
   * It's logged in and wants to go to login site
   * @param  {Event} event
   * @param  {Object} toState Rute
   */
  function avoidLoginScreen(event, toState) {
    if (toState.name === "login") {
      index(event);
    } else if (
      $localStorage.user.onlyCustomReports &&
      toState.name != "index.custom-reports" &&
      toState.name != "index.start-custom-report"
    ) {
      event.preventDefault();
      $state.go("index.custom-reports");
    }
  }

  /**
   * It's logged and the default head values are set
   */
  function headerOdoo() {
    if ($sessionStorage.user) {
      $http.defaults.headers.common.odooSession =
        $sessionStorage.user.sesionOdoo;
    }
  }

  /**
   * It has credentials in session, but not in local, it's logged out.
   * @param  {Event} event
   */
  function logoutFromAnotherPlace(event) {
    if (!$localStorage.user && !$sessionStorage.user) {
      event.preventDefault();
      $auth.logout();
      delete $sessionStorage.user;
      Notifications.addCustom(400, "You have logged out from another place");
      $state.go("login");
    }
  }

  /**
   * It has credentials in localStorage, but not in session, then credentials are loadeded into session
   * @param  {Event} event
   */
  function loginByRemember(event) {
    $sessionStorage.user = $localStorage.user;
    $auth.setToken($sessionStorage.user.token);
    index(event);
  }

  /**
   * It's not logged in at all, and wants to see a resource that requires login
   * @param  {Event} event
   * @param  {String} toState
   */
  function withoutLogin(event, toState) {
    if (!toState.free) {
      event.preventDefault();
      Notifications.addCustom(
        400,
        "You need to be logged in to see these resources"
      );
      $state.go("login");
    }
  }

  function index(event) {
    event.preventDefault();
    $state.go("index.clients");
  }
}

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/resources/i18n/en-US.json":[function(require,module,exports){
module.exports=module.exports = {
  "title": "Aries Solutions",
  "index.loading": "We're loading the application, please wait",
  "loadingbar": "We're processing your request, please wait.",
  "base.views.403.h1": "Access denied",
  "base.views.403.text": "Sorry, but your user does not have the required permissions to perform the requested action, contact the system administrator.",
  "base.views.404.h1": "Page not found",
  "base.views.404.text": "Sorry, the page your looking for can't be found, check that the URL is correct, and click on the 'refresh' icon or try to find something else inside the app",
  "base.views.messages.required": "This field is required",
  "base.views.messages.minlength": "This field is too short",
  "base.views.messages.maxlength": "This field is too long",
  "base.views.messages.email": "This field needs to be a valid email",
  "base.views.messages.password": "Must match the previous entry",
  "base.views.messages.pattern": "Wrong format",
  "base.views.navigation.logout": "Log out",
  "base.views.changePassword": "Change password",
  "login.views.login": "System login",
  "login.views.user": "User:",
  "login.views.pass": "Password:",
  "login.views.remember": "Remember me:",
  "login.views.odoo": "Login with Odoo",
  "login.views.firebase": "Login",
  "login.views.forgotPassword": "Forgot password?",
  "login.views.enterEmail": "Please enter the email associated to your Aries account where you will receive instructions to reset your password:",
  "admin.views.formUser.text": "You have all the permissions granted.",
  "admin.views.index.users": "Users",
  "admin.views.index.roles": "Roles",
  "admin.views.listRole.noData": "There are no Roles registered.",
  "admin.views.listRole.new": "New Role",
  "admin.views.listUser.noData": "There are no Users registered.",
  "admin.views.listUser.new": "New User",
  "admin.views.rolePermissions.admin": "Administration",
  "admin.views.rolePermissions.roles": "Roles",
  "admin.views.formUser.user": "User",
  "admin.views.rolePermissions.users": "Users",
  "common.new": "New",
  "common.create": "Create",
  "common.read": "Read",
  "common.edit": "Edit",
  "common.update": "Update",
  "common.back": "Go back",
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.delete": "Delete",
  "common.remove": "Remove",
  "common.rol": "Role",
  "common.name": "Name",
  "common.desc": "Description",
  "common.permissions": "Permissions",
  "common.email": "E-mail",
  "common.state": "State",
  "common.list": "List",
  "common.add": "Add",
  "common.select-small": "Select",
  "common.select": "Select file",
  "common.upload": "Upload",
  "common.abort": "Abort",
  "common.submit": "Submit",
  "common.activate": "Activate",
  "common.deactivate": "Deactivate",
  "routes.main.module": "Dashboard",
  "routes.base.404": "Page not found",
  "routes.base.403": "Access denied",
  "routes.admin.module.title": "Administration Module",
  "routes.admin.module.menu": "Administration",
  "routes.admin.user-list": "Users List",
  "routes.admin.user-form": "User Form",
  "routes.admin.role-list": "Roles List",
  "routes.admin.role-form": "Role Form",
  "client.views.listClients.noData": "There are no clients registered",
  "customer.views.listCustomers.noData": "There are no customers registered",
  "custom.report.create-report": "Create New Report",
  "custom.report.custom-reports": "Custom Reports",
  "custom.report.custom-report": "Custom Report",
  "custom.report.listCustomReports.noData": "There are no custom reports registered for this client",
  "custom.report.build-report": "Build Custom Report",
  "custom.report.questions": "Questions"
};

},{}],"/home/gitlab-runner/builds/02703733/0/firelab/firelab-dashboard/src/resources/i18n/es-CR.json":[function(require,module,exports){
module.exports=module.exports = {
  "title": "Proyecto Base - Ciris Informatic Solutions",
  "index.loading": "Estamos cargando la aplicación, por favor espere",
  "loadingbar": "Estamos procesando su solicitud, por favor espere.",
  "base.views.403.h1": "Acceso denegado",
  "base.views.403.text": "Lo sentimos, pero tu usuario no tiene los permisos necesarios para realizar la acción solicitada, ponte en contacto con el administrador del sistema.",
  "base.views.404.h1": "Página no encontrada",
  "base.views.404.text": "Lo sentimos, la página que buscas no se encuentra, compruebe que la URL sea correcta y haga clic en el icono 'refrescar' o trate de encontrar algo más dentro de la aplicación",
  "base.views.messages.required": "Este campo es requerido",
  "base.views.messages.minlength": "El valor es muy corto",
  "base.views.messages.maxlength": "El valor es muy largo",
  "base.views.messages.email": "Este campo necesita ser un correo válido",
  "base.views.navigation.logout": "Salir",
  "login.views.login": "Ingreso al Sistema",
  "login.views.user": "Usuario:",
  "login.views.pass": "Contraseña:",
  "login.views.remember": "Recuérdame:",
  "login.views.odoo": "Ingresar con Odoo",
  "login.views.firebase": "Ingresar con Firebase",
  "login.views.forgotPassword": "¿Olvidó su contraseña?",
  "login.views.enterEmail": "Por favor ingrese el correo asociado a su cuenta de Aries donde recibirá las instrucciones para restrablecer su contraseña:",
  "admin.views.formUser.text": "Usted tiene todos los permisos concedidos.",
  "admin.views.index.users": "Usuarios",
  "admin.views.index.roles": "Roles",
  "admin.views.listRole.noData": "No hay roles registrados aún.",
  "admin.views.listRole.new": "Nuevo Rol",
  "admin.views.listUser.noData": "No hay roles registrados aún.",
  "admin.views.listUser.new": "Nuevo Usuario",
  "admin.views.rolePermissions.admin": "Administración",
  "admin.views.rolePermissions.roles": "Roles",
  "admin.views.formUser.user": "Usuario",
  "admin.views.rolePermissions.users": "Usuarios",
  "common.new": "Nuevo",
  "common.create": "Crear",
  "common.read": "Lectura",
  "common.edit": "Editar",
  "common.update": "Actualizar",
  "common.back": "Atrás",
  "common.cancel": "Cancelar",
  "common.save": "Guardar",
  "common.delete": "Borrar",
  "common.remove": "Eliminar",
  "common.rol": "Rol",
  "common.name": "Nombre",
  "common.desc": "Descripción",
  "common.permissions": "Permisos",
  "common.email": "Correo",
  "common.state": "Estado",
  "common.list": "Lista",
  "common.add": "Agregar",
  "common.submit": "Enviar",
  "routes.main.module": "Inicio",
  "routes.base.404": "Página no encontrada",
  "routes.base.403": "Acceso Denegado",
  "routes.admin.module.title": "Módulo de Administración",
  "routes.admin.module.menu": "Administración",
  "routes.admin.user-list": "Lista de Usuarios",
  "routes.admin.user-form": "Form de Usuario",
  "routes.admin.role-list": "Lista de Roles",
  "routes.admin.role-form": "Form de Rol",
  "customer.views.listCustomers.noData": "No hay clientes registrados",
  "custom.report.create-report": "Crear Nuevo Reporte",
  "custom.report.custom-report": "Reporte Personalizado",
  "custom.report.custom-reports": "Reportes Personalizados",
  "custom.report.listCustomReports.noData": "No hay reportes personalizados registrados",
  "custom.report.questions": "Preguntas"
};

},{}]},{},["./src/app/index.js"]);
